import React, { ChangeEvent, useEffect, useRef, useState } from "react";
import { useParams, useMatch, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    Table,
    ContentLoader,
    TableBody,
    TableRow,
    Tooltip,
    TableCell,
    TableHeaderCell,
    TextOverflow,
    TableHead,
    Accordion,
    AccordionItem,
    SelectOptionSearch,
    Label,
    Input,
    TextArea,
    RadioButtonGroup,
    RadioButton,
    Checkbox,
    Select,
    SelectOption,
    CardContent,
    Card,
    Button,
    CardHeader,
    SearchIcon,
    EditIcon,
    ShowIcon,
    PlusIcon,
    Modal,
    Toggle,
    CloseIcon,
    ArrowLeftIcon,
    TableHeader,
    TableContent,
    TrashIcon,
    ControlError
} from "@forge/common";
import './create-course.scss';
import Header from "../common/components/header/header";
import {
    getvAppTemplatesList,
    getVmDetails,
    getAllvAppTemplatesAndVms,
    saveUpdateCourseDefinition,
    publishCourseDefinition,
    getCourseDataById,
    getNicNetwork,
    getNicNetworkAdapterType,
    getNicIpModes,
    getosVersionsList,
    resetCourseCreationState,
    vmPowerOnOff,
    resetCourseDefData,
    tokenGettingRefreshed,
    unMountISOFile,
    resetMountStatus,
} from "./store/create-course.action"
import { CREATE_COURSE_CONSTANTS, NETWORK_NONE, initialNicTableHeader, newVmTableHeaderData, existingVmTableHeaderData, VMTableHeader, LIBRARY_ROUTES } from "./utils/constants";
import LeftPanel from "../common/components/left-panel/left-panel";
import { IGeneralDetails, IVersion, IVMTable, IVMFormFields, INetworkList, INetworkAdapter, INicIPModes, IOSTypes, INewVMFormError, IGeneralDetailsFormError, INicFormError } from "./model/index";
import NewVMFromExistingTemplate from "./vm-template/vm-template"
import ViewVMExistingTemplate from "./view-vm-template/view-vm-template"
import NewVirtualMachine from "./new-vm/new-vm";
import MountISOComponent from "./mount-iso/mount-iso";
import NicConfiguration from "./nic-configuration/nic-configuration";
import CreateCourseHeader from "./create-course-header/create-course-header";
import GeneralDetailsSection from "./general-details-section/general-details-section";
import PublishWarningModal from "./publish-warning-modal/publish-warning-modal";
import CancelConfirmationModal from "./cancel-confirmation-modal/cancel-confirmation-modal";
import UnMountISOConfirmationModal from "./un-mount-confirmation-modal/un-mount-confirmation-modal";
import PowerOffConfirmationModal from "./power-off-confirmation-modal/power-off-confirmation-modal";
import containsHTMLOrScript from "../common/utils/htmlScriptValidation";
import { AppState } from "../../../../common/store/combinedReducer";
import { fetchFileList } from "../iso-file-management/store/iso-file-management.action";
import connected from '../../../../common/assets/connected.png';
import disconnected from '../../../../common/assets/disconnected.png';
import mountIso from '../../../../common/assets/mount.png';
import unmountIso from '../../../../common/assets/unmount.png';
import powerOffIcon from '../../../../common/assets/vm-poweroff.png';
import powerOnIcon from '../../../../common/assets/vm-poweron.png';
import autoPause from '../../../../common/assets/autopause-rounded.svg';
import { closeConnection, setUpSignalRConnection } from "../../../../common/utility/Dashboard/utility";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { getWMKSDetails, clearWMKSDetails, setSignalR, getPowerOn } from "../../../store/action";
import config from "../../../../common/authentication/config";
import WarningPopup from "../view-course/popup/warning";
import { hideModel, showLoader, showModel, showToast } from "../store/model/model.action";
import { VIEW_COURSE_CONSTANTS } from "../view-course/utils/constants";


const CreateCourse = () => {
    const initialVmFormData = {
        vmId: '',
        vmName: '',
        description: '',
        cpu: '',
        ram: '',
        ramUnit: 'MB' as 'MB' | 'GB',
        storage: '',
        osType: '',
        osVersion: '',
        bootImage: '',
        bootImageName: '',
        bootFirmware: 'EFI',
        isFromAPI: false,
        bootSetup: true,
        vmAutoPause: false,
        existingVm: '',
        powerOn: false,
        creationType: 'fromVm' as 'fromVm' | 'fromTemplate'
    };
    const initialNicFormData = {
        network: '',
        networkAdapterType: '',
        ipMode: '',
        ipAddress: '',
        ipType: 'IPV4',
        macAddress: '',
        primaryNic: false,
        connected: true,
    };
    const initialVmFormError = {
        vmName: '',
        description: '',
        cpu: '',
        ram: '',
        storage: '',
        osType: '',
        osVersion: '',
        bootImage: '',
        bootFirmware: '',
        existingVm: '',
        atleastoneNic: '',
        atleastonePrimaryNic: '',
        atleastoneVm: ''
    };
    const initialNicError = {
        network: '',
        networkAdapterType: '',
        ipMode: '',
        ipAddress: '',
        ipType: '',
        primaryNic: false,
        connected: '',
    };
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { courseId } = useParams();
    const isCopyMode = !!useMatch('/academy/copycourse/:courseId');
    const isEditMode = !!courseId && !isCopyMode;
    const vAppTemplates: any = useSelector((state: AppState) => {
        return state.createCourseReducer.vAppTemplates || [];
    });
    const vmTableData: any = useSelector((state: AppState) => {
        return state.createCourseReducer.vmDetails.tableData || [];
    });
    const isVmTableLoading: any = useSelector((state: AppState) => {
        return state.createCourseReducer.vmDetails.isTableLoading;
    });
    const courseDefData: any = useSelector((state: AppState) => {
        return state.createCourseReducer.courseDefinitionData.courseDefData;
    });
    const courseDefError: any = useSelector((state: AppState) => {
        return state.createCourseReducer.courseDefinitionData.error;
    });
    const osVersions: any = useSelector((state: AppState) => {
        return state.createCourseReducer.osVersions || [];
    });
    const userDetail: any = useSelector((state: AppState) => {
        return state.reducer.userInfo;
    });
    const wmksDetails = useSelector((state: AppState) => {
        return state.reducer.wmksDetails;
    });
    const wmksStatus = useSelector((state: AppState) => {
        return state.reducer.wmksStatus;
    });
    const nicNetwork = useSelector((state: AppState) => {
        return state.createCourseReducer.networkList;
    });
    const nicNetworkAdapterType = useSelector((state: AppState) => {
        return state.createCourseReducer.nicNetworkAdapterTypes;
    });
    const nicIpModes = useSelector((state: AppState) => {
        return state.createCourseReducer.nicIpModes;
    });
    const osListReducer = useSelector((state: AppState) => {
        return state.createCourseReducer.osList;
    });
    const templatesTableData: any = useSelector((state: AppState) => {
        return state.createCourseReducer.vAppTemplatesList.tableData || [];
    });
    const isvAppVmTableLoading: any = useSelector((state: AppState) => {
        return state.createCourseReducer.vAppTemplatesList.isTableLoading;
    });
    const isoFileList = useSelector((state: AppState) => {
        return state.isoFileManagementReducer.isoFileList;
    });
    const signalRConnection = useSelector((state: AppState) => {
        return state.reducer.signalR;
    });
    const courseCreationState = useSelector((state: AppState) => {
        return state.createCourseReducer.courseCreation;
    });
    const tokenRefreshStatus = useSelector((state: AppState) => {
        return state.createCourseReducer.tokenStatus;
    });
    const isoMountStatus = useSelector((state: AppState) => {
        return state.createCourseReducer.isoMountStatus;
    });
    const isoMountMessage = useSelector((state: AppState) => {
        return state.createCourseReducer.isoMountMessage;
    });
    const isoUnmountStatus = useSelector((state: AppState) => {
        return state.createCourseReducer.isoUnmountStatus;
    });
    const isoUnmountMessage = useSelector((state: AppState) => {
        return state.createCourseReducer.isoUnmountMessage;
    });
    const generateCpuOptions = () => {
        const options = [];
        for (let i = 1; i <= 64; i++) {
            options.push({
                label: i.toString(),
                value: i.toString()
            });
        }
        return options;
    };
    const [vmIdCounter, setVmIdCounter] = useState<number>(1);
    const [listofvAppTemplatesDropDown, setListofvAppTemplatesDropDown] = useState<{ id: string; name: string }[]>([]);
    const [showLeftPanel, setShowLeftPanel] = useState<boolean>(false);
    const [createorEditVm, setCreateorEditVm] = useState<boolean>(false);
    const [availableOsVersions, setAvailableOsVersions] = useState<any[]>([]);
    const [templateAssociation, setTemplateAssociation] = useState<'existing' | 'new'>('existing');
    const [vmAssociation, setVMAssociation] = useState<'fromVm' | 'fromTemplate'>('fromVm');
    const [generalDetails, setGeneralDetails] = useState<IGeneralDetails>({
        courseId: "",
        courseName: "",
        courseStage: 0,
        courseDuration: "",
        courseDescription: "",
        templateAssociate: "",
        vAppTemplate: "",
        vAppTemplateName: "",
        lastModifiedDate: "",
        lastModifiedBy: ""
    });
    const [generalDetailsFormError, setGeneralDetailsFormError] = useState<IGeneralDetailsFormError>({
        courseName: '',
        courseDuration: '',
        courseDescription: '',
        templateAssociate: '',
        vAppTemplate: '',
        vAppTemplateName: '',
        atleastonevm: ''
    })
    const [vmFormData, setVmFormData] = useState<IVMFormFields>({
        vmId: '',
        vmName: '',
        description: '',
        cpu: '',
        ram: '',
        ramUnit: 'MB',
        storage: '',
        osType: '',
        osVersion: '',
        bootImage: '',
        bootImageName: '',
        bootFirmware: 'EFI',
        bootSetup: true,
        isFromAPI: false,
        vmAutoPause: false,
        powerOn: false,
        existingVm: '',
        creationType: 'fromVm'
    })
    const [vmFormError, setVmFormError] = useState<INewVMFormError>({
        vmName: '',
        description: '',
        cpu: '',
        ram: '',
        storage: '',
        osType: '',
        osVersion: '',
        bootImage: '',
        bootFirmware: '',
        existingVm: '',
        atleastoneNic: '',
        atleastonePrimaryNic: '',
        atleastoneVm: ''
    })
    const [nicFormData, setNicFormData] = useState<{ network: string; networkAdapterType: string, ipMode: string, ipAddress: string, ipType: string, primaryNic: boolean, connected: boolean, macAddress: string, }>({
        network: '',
        networkAdapterType: '',
        ipMode: '',
        ipAddress: '',
        ipType: 'IPV4',
        macAddress: '',
        primaryNic: false,
        connected: true,
    });
    const [nicError, setNicError] = useState<INicFormError>({
        network: '',
        networkAdapterType: '',
        ipMode: '',
        ipAddress: '',
        ipType: '',
        primaryNic: false,
        connected: '',
    });
    const [nicTableData, setNicTableData] = useState<any[]>([]);
    const [originalNicData, setOriginalNicData] = useState<any[]>([]);
    const [showNicForm, setShowNicForm] = useState<boolean>(false);
    const [showCancelConfirmation, setShowCancelConfirmation] = useState<boolean>(false);
    const [cpuOptions] = useState(generateCpuOptions());
    const [filterType, setFilterType] = useState<string>('Name');
    const [searchQuery, _setSearchQuery] = useState<string>('');
    const setSearchQuery = (val: string) => _setSearchQuery(typeof val === 'string' ? val.trim() : val);
    /**  IF EXISTING TEMPLATE */
    const [tableData, setTableData] = useState<IVMTable[]>([]);
    const [vmTable, setVmTable] = useState<IVMTable[]>([]);
    /** IF NEW TEMPLATE */
    const [newTableData, setNewTableData] = useState<IVMTable[]>([]);
    const [newVmTable, setNewVmTable] = useState<IVMTable[]>([]);
    const [templateSearchQuery, setTemplateSearchQuery] = useState<string>('');
    const [selectedVms, setSelectedVms] = useState<Record<string, IVMTable | undefined>>({});
    const [newSelectedVms, setNewSelectedVms] = useState<Record<string, IVMTable | undefined>>({});
    const [selectedTemplateData, setSelectedTemplateData] = useState<any>({});
    const [newVmsList, setNewVmsList] = useState<any[]>([]);
    const [actionType, setActionType] = useState<'draft' | 'publish'>('draft');
    const [originalVmData, setOriginalVmData] = useState<any>(null);
    const [showPublishWarning, setShowPublishWarning] = useState<boolean>(false);
    const [originalFormData, setOriginalFormData] = useState<any>(null);
    const [vmPowerOnStatus, setVmPowerOnStatus] = useState<boolean>(false);
    const [selectedVmId, setSelectedVmId] = useState<string | null>(null);
    const [showPowerOn, setShowPowerOn] = useState<boolean>(true);
    const [confirmationSource, setConfirmationSource] = useState<'cancel' | 'back' | null>(null);
    const isNotEmpty = (arr: any[]): boolean => arr.length > 0;
    const [openVm, setOpenVm] = React.useState(false);
    const [vmDetails, setVmDetails] = React.useState<any>({});
    const [showMountISOComponent, setShowMountISOComponent] = useState<boolean>(false);
    const [powerOffConfirmation, setPowerOffConfirmation] = useState<boolean>(false);
    const [showUnMountISOConfirmation, setShowUnMountISOConfirmation] = useState<boolean>(false);
    const [isoTableData, setIsoTableData] = useState<any[]>([]);
    const [selectedVmNameForPowerOff, setSelectedVmNameForPowerOff] = useState<string>('');
    const [selectedVmForPowerOff, setSelectedVmForPowerOff] = useState<any>(null);
    const [showViewVmDetailsModal, setShowViewVmDetailsModal] = React.useState<boolean>(false);
    const [viewVmDetailsData, setViewVmDetailsData] = React.useState<any[]>([]);
    const [newVmTableHeaders, setNewVmTableHeaders] = useState(newVmTableHeaderData);
    const [existingVmTableHeaders, setExistingVmTableHeaders] = useState(existingVmTableHeaderData);
    const [signalrConnection, setSignalrConnection] = useState<HubConnection>(signalRConnection);
    let openedTabs: any;
    const isInitialLoad = useRef(true);
    useEffect(() => {
        dispatch(getvAppTemplatesList());
    }, [])

    useEffect(() => {
        if (signalRConnection === undefined || !signalRConnection || !signalRConnection?.state) {
            dispatch(setSignalR(signalrConnection));
        }
    }, [signalrConnection, signalRConnection]);

    useEffect(() => {
        /** Restablish the connection when token is refreshed */
        if (courseDefData && Object.keys(courseDefData).length > 0 && (!signalRConnection ||
            signalRConnection.state === HubConnectionState.Disconnected) && tokenRefreshStatus) {
            /** Set up SignalR connection for Edit course page in academy */
            setUpSignalRConnection(courseDefData.courseName, dispatch, undefined, true, true, courseDefData.id, courseDefData);
            dispatch(tokenGettingRefreshed(false));
        }
    }, [signalRConnection]);

    useEffect(() => {
        if (wmksStatus === 409 && wmksDetails?.message) {
            // Show toast for VM in use
            dispatch(showToast({
                type: "error",
                title: "",
                subtitle: wmksDetails.message
            }));
            setOpenVm(false);
            dispatch(clearWMKSDetails());
            return;
        }
        if (wmksDetails?.host !== null && wmksDetails?.host !== undefined && openVm && wmksStatus === 200) {
            if (vmDetails?.vmName) {
                window
                    .open(
                        `/dashboard/vmware/${config?.SITE_ID}/${vmDetails?.vmName}`,
                        "",
                        "noopener"
                    )
                    ?.focus();
                localStorage.setItem(
                    vmDetails?.vmName,
                    JSON.stringify({
                        name: vmDetails?.vmName,
                        id: vmDetails?.vmId,
                        orgId: config?.ACADEMY_TENANT_ID,
                        orgName: vmDetails?.orgName,
                        tenantId: config?.ACADEMY_TENANT_ID,
                        siteId: config?.SITE_ID,
                        wmksData: wmksDetails,
                        isVmWindow: true,
                    })
                );
                // openedTabs = Number(localStorage.getItem("openedTabs") || "0");
                // openedTabs += 1;
                // localStorage.setItem("openedTabs", openedTabs?.toString());
                setOpenVm(false);
            }
        }
    }, [wmksDetails, wmksStatus]);

    const getMksToken = async (data: any) => {
        openedTabs = Number(localStorage.getItem("openedTabs") || "0");
        if (openedTabs >= 10) {
            dispatch(
                showToast({
                    type: "error",
                    title: "",
                    subtitle: CREATE_COURSE_CONSTANTS.MAX_VMS_OPENED,
                })
            );
        } else {
            dispatch(
                showModel({
                    childTemplate: () => (
                        <WarningPopup
                            title={"!Warning!"}
                            description={
                                "Install antivirus software on the available nodes to ensure the optimum cyber security and protection."
                            }
                            btnText={VIEW_COURSE_CONSTANTS.CANCEL}
                            btnText1={VIEW_COURSE_CONSTANTS.CONFIRM}
                            onCancel={() => dispatch(hideModel())}
                            onTrigger={() => {
                                setVmDetails({
                                    vmId: `vm-${data?.vcdVmID}`,
                                    vmName: data?.vmName,
                                    orgName: originalFormData?.courseName
                                });
                                dispatch(hideModel());
                                dispatch(
                                    getWMKSDetails({
                                        id: `vm-${data?.vcdVmID}`,
                                        orgId: config?.ACADEMY_ORGID,
                                        accessToken: localStorage.getItem("access_token"),
                                        siteId: config?.SITE_ID,
                                        orgName: originalFormData?.courseName,
                                        tenantId: config?.ACADEMY_TENANT_ID,
                                    })
                                );
                                setOpenVm(true);
                            }}
                        />
                    ),
                })
            );
        }
    };

    useEffect(() => {
        if (courseCreationState?.isSuccess) {
            if (isEditMode) {
                if (actionType === 'publish') {
                    dispatch(showToast({
                        type: "success",
                        subtitle: `${courseCreationState.error}`
                    }));
                } else {
                    // Draft/Update action
                    dispatch(showToast({
                        type: "success",
                        subtitle: `Template "${courseCreationState.error}" updation is in progress.`
                    }));
                }
                // Close COURSE-SPECIFIC connection
                closeConnection(signalRConnection, HubConnectionState, dispatch);
                isInitialLoad.current = false;
            } else {
                // Create/Copy mode
                dispatch(showToast({
                    type: "success",
                    subtitle: `Template "${courseCreationState.error}" creation in progress.`
                }));
            }
            navigate('/academy/viewCourseTemplates');
            dispatch(resetCourseCreationState());
        }
        if (courseCreationState?.isError) {
            let errorTitle = '';
            let errorContent = '';
            if (actionType === 'publish') {
                errorTitle = CREATE_COURSE_CONSTANTS.TOAST_MSGS.PUBLISH_COURSE_FAILURE;
                errorContent = courseCreationState.error || CREATE_COURSE_CONSTANTS.TOAST_MSGS.PUBLISH_COURSE_FAILURE;
            } else if (isEditMode) {
                errorTitle = CREATE_COURSE_CONSTANTS.TOAST_MSGS.UPDATE_COURSE_FAILURE;
                errorContent = courseCreationState.error || CREATE_COURSE_CONSTANTS.TOAST_MSGS.UPDATE_COURSE_FAILURE;
            } else {
                errorTitle = CREATE_COURSE_CONSTANTS.TOAST_MSGS.CREATE_COURSE_FAILURE;
                errorContent = courseCreationState.error || CREATE_COURSE_CONSTANTS.TOAST_MSGS.CREATE_COURSE_FAILURE;
            }
            dispatch(showToast({
                type: "error",
                title: errorTitle,
                content: errorContent
            }));
            dispatch(resetCourseCreationState());
        }
    }, [courseCreationState?.isSuccess, courseCreationState?.isError, courseCreationState?.error, navigate, isEditMode, actionType]);


    useEffect(() => {
        if (vAppTemplates && vAppTemplates.length > 0) {
            setListofvAppTemplatesDropDown(vAppTemplates);
        }
    }, [vAppTemplates]);

    useEffect(() => {
        if (vmTableData && Array.isArray(vmTableData.vmList) && vmTableData.vmList.length > 0) {
            const transformedData = transformVMData(vmTableData.vmList);
            setTableData(transformedData);
            setVmTable(transformedData);
        }
    }, [vmTableData]);


    useEffect(() => {
        if ((isEditMode || isCopyMode) && courseId) {
            dispatch(getCourseDataById(courseId));
            dispatch(getNicNetwork());
            dispatch(getNicNetworkAdapterType());
            dispatch(getNicIpModes());
            dispatch(fetchFileList(1, true));
        }
    }, [isEditMode, isCopyMode])

    useEffect(() => {
        if (Array.isArray(isoFileList) && isoFileList.length > 0) {
            setIsoTableData(isoFileList);
        } else if (Array.isArray(isoFileList) && isoFileList.length === 0) {
            setIsoTableData([]);
        }
    }, [isoFileList]);

    useEffect(() => {
        if (isoMountStatus === 409) {
            setShowMountISOComponent(false);
            dispatch(showToast({
                type: "error",
                title: "",
                subtitle: isoMountMessage,
            }));
            dispatch(resetMountStatus());
            setSelectedVmForPowerOff(null);
        } else {
            setShowMountISOComponent(false);
            setSelectedVmForPowerOff(null);
        }
    }, [isoMountStatus, isoMountMessage]);

    useEffect(() => {
        if (isoUnmountStatus === 409) {
            dispatch(showToast({
                type: "error",
                title: "",
                subtitle: isoUnmountMessage,
            }));
            dispatch(resetMountStatus());
            setSelectedVmForPowerOff(null);
        } else {
            setSelectedVmForPowerOff(null);
        }
    }, [isoUnmountStatus, isoUnmountMessage]);

    useEffect(() => {
        /*** Start - Initialize form Data in edit mode */
        if ((isEditMode || isCopyMode) && courseDefData && Object.keys(courseDefData).length > 0) {
            if (isInitialLoad.current) {
                // Close any existing connection before establishing a new one for the course being edited
                closeConnection(signalRConnection, HubConnectionState, dispatch);
                // Establish COURSE-SPECIFIC connection for power on off and other real-time updates related to the course being edited
                setUpSignalRConnection(
                    courseDefData.courseName,
                    dispatch,
                    setSignalrConnection,
                    true,
                    true,
                    courseDefData.id,
                    courseDefData
                );
                isInitialLoad.current = false; // Mark as loaded
            }
            const courseData = courseDefData;
            setGeneralDetails(prev => ({
                ...prev,
                courseId: courseData.id,
                courseOrgId: courseData.courseOrgId,
                courseName: courseData.courseName,
                courseDescription: courseData.courseDescription,
                courseDuration: courseData.duration,
                vAppTemplate: courseData.vAppTemplate,
                templateAssociate: 'existing',
                vAppTemplateName: courseData.vAppTemplateName,
                courseStage: courseData.courseStage,
                lastModifiedBy: courseData.lastModifiedBy,
                lastModifiedDate: courseData.lastModifiedDate,
                siteId: courseData.siteId
            }));
            // Store original data for comparison
            setOriginalFormData(courseData);
            // Set VM table data with validation
            if (courseData.vmDetails && Array.isArray(courseData.vmDetails) && courseData.vmDetails.length) {
                setTableData(courseData.vmDetails);
                setVmTable(courseData.vmDetails);
            } else {
                setTableData([]);
                setVmTable([]);
            }
        } else if ((isEditMode || isCopyMode) && courseDefData && Object.keys(courseDefData).length === 0 && courseDefError) {
            dispatch(showToast({
                type: "error",
                title: "Failed to Load Course Data",
                content: courseDefError
            }));
        }
        /*** End - Initialize form Data in edit mode */
    }, [courseDefData]);

    useEffect(() => {
        if (osVersions && osVersions.length > 0) {
            setAvailableOsVersions(osVersions);
        }
        // Don't set anything if osVersions is null/undefined
    }, [osVersions]);

    React.useEffect(() => {
        setTemplateAssociation('existing');
        setGeneralDetails(prev => ({
            ...prev,
            templateAssociate: 'existing'
        }));
    }, []);

    useEffect(() => {
        setVmTable(tableData);
    }, [tableData]);

    useEffect(() => {
        if (originalNicData.length > 0) {
            const updatedTableData = originalNicData.map(nic => ({
                id: `nic-${nic.id}`,
                cell: [
                    {
                        content: (<TextOverflow
                            lines={1}
                            tooltipPosition="top"
                        >
                            {nic.id}
                        </TextOverflow>),
                        className: 'vpp-table-border !w-[90px] !max-w-[90px] !min-w-[90px]'
                    },
                    {
                        content: nic.connected ? <img src={connected} alt="connected Icon" /> : <img src={disconnected} alt="disconnected Icon" />,
                        className: "vpp-table-border"
                    },
                    {
                        content: <TextOverflow
                            lines={1}
                            tooltipPosition="top"
                        >
                            {nic.macAddress || '--'}
                        </TextOverflow>,
                        className: 'vpp-table-border !w-[90px] !max-w-[90px] !min-w-[90px]'
                    },
                    {
                        content: (
                            <TextOverflow
                                lines={1}
                                tooltipPosition="top"
                            >
                                {nic.network}
                            </TextOverflow>
                        ),
                        className: 'vpp-table-border !w-[90px] !max-w-[90px] !min-w-[90px]'
                    },
                    {
                        content: (
                            <TextOverflow
                                lines={1}
                                tooltipPosition="top"
                            >
                                {nic.networkAdapter}
                            </TextOverflow>
                        ),
                        className: 'vpp-table-border !w-[110px] !max-w-[110px] !min-w-[110px]'
                    },
                    {
                        content: nic.ipMode,
                        className: 'vpp-table-border'
                    },
                    {
                        content: (
                            <TextOverflow
                                lines={1}
                                tooltipPosition="top"
                            >
                                {nic.ipType}
                            </TextOverflow>
                        ),
                        className: 'vpp-table-border !w-[63px] !max-w-[63px] !min-w-[63px]'
                    },
                    {
                        content: (
                            <TextOverflow
                                lines={1}
                                tooltipPosition="top"
                            >
                                {nic.ipAddress || '--'}
                            </TextOverflow>
                        ),
                        className: 'vpp-table-border !w-[85px] !max-w-[85px] !min-w-[85px]'
                    },
                    {
                        content: (
                            <div style={{ width: '80px', display: 'flex', justifyContent: 'center' }}>
                                <RadioButton
                                    success
                                    name="primary-nic"
                                    id={`primary-nic-${nic.id}`}
                                    disabled={vmPowerOnStatus}
                                    data-testid={`primary-nic-${nic.id}`}
                                    value={`${nic.id}`}
                                    checked={nic.isPrimary}
                                    onChange={() => handleSetPrimaryNic(nic.id)}
                                />
                            </div>
                        ),
                        className: "vpp-table-border"
                    },
                    {
                        content: (
                            <div style={{ width: '70px', display: 'flex', justifyContent: 'center' }}>
                                <Button
                                    className="text-xs"
                                    id={`delete-nic-${nic.id}`}
                                    data-testid={`delete-nic-${nic.id}`}
                                    icon={<TrashIcon strokeWidth={2} />}
                                    disabled={getPrimaryNicStatus(nic) || vmPowerOnStatus}
                                    onClick={() => handleDeleteNic(nic.id)}
                                    size="regular"
                                    variant="quiet-primary"
                                    aria-label="Delete"
                                    iconPosition="right"
                                />
                            </div>
                        ),
                        className: "vpp-table-border"
                    }
                ]
            }));
            setNicTableData(updatedTableData);
        } else {
            setNicTableData([]);
        }
    }, [originalNicData]);

    const calculatePaginationInfo = () => {
        const totalItems = vmTable.length;
        if (totalItems === 0) return { start: 0, end: 0, total: 0 };

        return {
            start: totalItems > 0 ? 1 : 0,
            end: totalItems,
            total: totalItems
        };
    };

    const paginationInfo = calculatePaginationInfo();

    const transformVMData = (apiResponse: any[]) => {
        return apiResponse.map((vm: any, index: number) => ({
            id: vm.vmId ? vm.vmId : String(index + 1), // Handle empty GUID
            vmName: vm.vmName || '--',
            vmDescription: vm.vmDescription,
            powerOn: vm.isPowerOn,
            vmURL: vm.vmURL,
            osType: vm.osType || '--',
            osVersion: vm.osVer || '--',
            ram: `${vm.ramValue} ${vm.ramUnit}` || '--',
            ipAddress: vm.ipAddress || '--',
            cpu: vm.cpu ? `${vm.cpu} Cores` : '--',
            storage: vm.storage || '--',
            vmPause: vm.isPausable === "true" ? "Yes" :
                vm.isPausable === "false" ? "No" : "--",
            originalvAppTemplateID: vm.originalvAppTemplateID,
            osVersionID: vm.osVersionId,
            ramUnit: vm.ramUnit,
            nicConfig: []
        }));
    };

    const toggleSelectALl = (e: ChangeEvent<HTMLInputElement>) => {
        const selected: Record<string, IVMTable | undefined> = tableData.reduce((acc, cur: IVMTable) => ({
            ...acc,
            [cur.id as string]: e.target.checked ? cur : undefined
        }), {} as Record<string, IVMTable | undefined>);
        setSelectedVms(selected);
        generalDetailsFormError.atleastonevm = '';
    };
    const toggleSelectAllNewVmTable = (e: ChangeEvent<HTMLInputElement>) => {
        const selected: Record<string, IVMTable | undefined> = newTableData.reduce((acc, cur: IVMTable) => ({
            ...acc,
            [cur.id as string]: e.target.checked ? cur : undefined
        }), {} as Record<string, IVMTable | undefined>);
        setNewSelectedVms(selected);
        generalDetailsFormError.atleastonevm = '';
    };
    const onItemSelect = (data: IVMTable, isChecked: boolean) => {
        generalDetailsFormError.atleastonevm = '';
        setSelectedVms(prevState => ({
            ...prevState,
            [String(data.id)]: isChecked ? data : undefined
        }));
    };
    const onItemSelectNewVmTable = (data: IVMTable, isChecked: boolean) => {
        generalDetailsFormError.atleastonevm = '';
        setNewSelectedVms(prevState => ({
            ...prevState,
            [String(data.id)]: isChecked ? data : undefined
        }));
    };
    const selectedItemsIds = Object.keys(selectedVms).map(key => selectedVms[key]?.id).filter(Boolean);
    const newSelectedItemsIds = Object.keys(newSelectedVms).map(key => newSelectedVms[key]?.id).filter(Boolean);
    const handleClickHam = () => {
        setShowLeftPanel((prev) => !prev);
    }
    const createNewVm = () => {
        setCreateorEditVm(true);

    }
    /**
     * This function handles the form reset option.
     */
    const closeAndReset = (resetCounter: boolean = true, isClosingModal: boolean = true) => {
        setVmFormData(initialVmFormData);
        setNicFormData(initialNicFormData);
        setVmFormError(initialVmFormError);
        setNicError(initialNicError);
        setNicTableData([]);
        setOriginalNicData([]);
        setOriginalVmData(null);
        setSelectedVmId(null);
        setShowPowerOn(true);
        setShowNicForm(false);
        if (isClosingModal) {
            setVMAssociation('fromVm');
        }
        setAvailableOsVersions([]);
        setSelectedTemplateData({});
        setCreateorEditVm(false);
        if (resetCounter) {
            setVmIdCounter(1);
        }
        setVmPowerOnStatus(false);
    }

    /**
     * This function validates the course name input.
     * @param value 
     * @returns 
     */
    const validateCourseName = (value: string) => {
        if (value.length > 30) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_NAME_LENGTH;
        }
        const orgNamePattern = /^[a-zA-Z][a-zA-Z0-9_]*$/;
        if (!orgNamePattern.test(value)) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_NAME_INVALID_CHARS;
        } else {
            return "";
        }
    };

    /**
     * This function validates the course template name input.
     * @param value 
     * @returns 
     */
    const validateTemplateName = (value: string) => {
        if (value.length > 50) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.TEMP_NAME;
        } else if (containsHTMLOrScript(value)) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.ELEMENT_ERROR;
        } else if (value.trim() && !/^[a-zA-Z0-9\s,.\-_]+$/.test(value)) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.TEMP_INVALID_CHARACTERS;
        } else {
            return "";
        }
    };

    /**
     * This function validates the course description input.
     * @param value 
     * @returns 
     */
    const validateDescription = (value: string) => {
        if (value.length > 250) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.ERROR;
        } else if (containsHTMLOrScript(value)) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.ELEMENT_ERROR;
        } else if (value.trim() && !/^[a-zA-Z0-9\s,.\-_]+$/.test(value)) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.INVALID_CHARACTERS;
        } else {
            return "";
        }
    };

    /**
     * This function validates the course duration input.
     * @param value 
     * @returns 
     */
    const validateCourseDuration = (value: any) => {
        if (!value || value === '' || value === null || value === undefined) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_DURATION_REQUIRED;
        }
        const numValue = Number(value);
        if (numValue < 1) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_DURATION_MIN;
        }
        if (numValue > 30) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_DURATION_MAX;
        }
        return '';
    };
    /**
     * This function handles the back navigation action.
     */
    const handleAddNicClick = () => {
        setShowNicForm(true);
    };

    /**
     * This function handles the deletion of a NIC from the table.
     * @param id 
     */
    const handleDeleteNic = (id: number) => {
        if (originalNicData.length <= 1) {
            dispatch(showToast({
                type: "warning",
                title: "Cannot Delete NIC",
                subtitle: "At least one NIC is required for the virtual machine."
            }));
            return;
        }
        const updatedNics = originalNicData.filter(nic => nic.id !== id);
        setOriginalNicData(updatedNics);
        setNicTableData(prev => prev.filter(row => !row.id.includes(`nic-${id}`)));
        if (updatedNics.length > 0 && !updatedNics.some(nic => nic.isPrimary)) {
            handleSetPrimaryNic(updatedNics[0].id);
        }
    };
    const handleSetPrimaryNic = (id: number) => {
        setOriginalNicData(prev => prev.map(nic => ({
            ...nic,
            isPrimary: nic.id === id
        })));

        setNicTableData(prev => prev.map(row => {
            const nicId = parseInt(row.id.replace('nic-', ''));
            const updatedCells = [...row.cell];
            updatedCells[8] = {
                content: <RadioButton
                    success
                    name="primary-nic"
                    id={`primary-nic-${nicId}`}
                    value={`${nicId}`}
                    checked={nicId === id}
                    onChange={() => handleSetPrimaryNic(nicId)}
                />
            };

            return {
                ...row,
                cell: updatedCells
            };
        }));
    };
    /**
 * Handle changes in the NIC form fields.
 * This function updates the NIC form data and validates the IP address if necessary.
 * @param field 
 * @param value 
 */
    const handleNicFormChange = (field: 'network' | 'networkAdapterType' | 'ipMode' | 'ipAddress' | 'ipType' | 'primaryNic' | 'connected', value: string) => {
        const isNone = field === 'network' && value.toLowerCase() === NETWORK_NONE;
        if (isNone) {
            setNicFormData(prev => ({
                ...prev,
                [field]: value,
                networkAdapterType: 'None',
                ipMode: 'None',
                ipAddress: 'None',
            }));
            setNicError(prev => ({
                ...prev,
                network: '',
                networkAdapterType: '',
            }));
        } else if (field === "network" && !isNone) {
            const wasNone = nicFormData.network.toLowerCase() === NETWORK_NONE;
            setNicFormData(prev => ({
                ...prev,
                [field]: value,
                // Only reset dependent fields if coming from 'None'
                ...(wasNone && {
                    networkAdapterType: '',
                    ipMode: '',
                    macAddress: '',
                    ipAddress: '',
                }),
                ipType: 'IPV4'
            }));
        }
        if (field === 'ipMode') {
            setNicFormData(prev => ({
                ...prev,
                [field]: value,
                ipAddress: value === 'manual' ? '' : 'Auto-assigned'
            }));
            if (value !== 'manual') {
                setNicError(prev => ({
                    ...prev,
                    ipAddress: ''
                }));
            }
        } else if (field === 'ipAddress' && typeof value === 'string') {
            setNicFormData(prev => ({
                ...prev,
                ipAddress: value
            }));

            if (nicFormData.ipMode === 'manual') {
                const { error: ipError, normalized } = validateIpAddress(value);
                setNicFormData(prev => ({ ...prev, ipAddress: normalized }));
                setNicError(prev => ({
                    ...prev,
                    ipAddress: ipError
                }));
            }
        } else {
            setNicFormData(prev => ({
                ...prev,
                [field]: value
            }));
        }

        if (field !== 'ipAddress' && nicError[field]) {
            setNicError(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };

    const getIpModeId = (ipMode: string): number => {
        const normalizedIpMode = (ipMode || NETWORK_NONE).toLowerCase();
        const noneModeId = nicIpModes.find(
            (mode: INicIPModes) => mode.ipModeValue.toLocaleLowerCase() === NETWORK_NONE
        )?.id || 1;
        return nicIpModes.find(
            (mode: INicIPModes) => mode.ipModeValue.toLocaleLowerCase() === normalizedIpMode
        )?.id || noneModeId;
    };

    /**
     * This function validates the IP address format.
     * It checks if the IP address is in a valid IPv4 format and within the acceptable
     * @param ipAddress 
     * @returns 
     */
    const validateIpAddress = (ipAddress: string): { error: string; normalized: string } => {
        if (!ipAddress.trim()) {
              return { error: CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.IP_ADDRESS_REQUIRED, normalized: ipAddress };
        }
        const ipv4Regex = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
        if (!ipv4Regex.test(ipAddress.trim())) {
            return { error: CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.INVALID_IP1, normalized: ipAddress };
        }
        const octets = ipAddress.trim().split('.');
        const parsedOctets = octets.map(o => parseInt(o, 10));
        if (parsedOctets[0] !== 192 || parsedOctets[1] !== 168) {
            return { error: CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.INVALID_IP2, normalized: ipAddress };
        }
        for (let i = 0; i < parsedOctets.length; i++) {
            if (isNaN(parsedOctets[i]) || parsedOctets[i] < 1 || parsedOctets[i] > 255) {
                return { error: 'Each segment must be between 1-255', normalized: ipAddress };
            }
        }
        const normalized = parsedOctets.join('.');
        return { error: '', normalized };
    };
    /**
    * This function handles the addition of a NIC to the table.
    * @returns 
    */
    const handleAddNicToTable = () => {
        const newErrors = {
            network: '',
            networkAdapterType: '',
            ipMode: '',
            ipAddress: '',
            ipType: '',
            primaryNic: false,
            connected: ''
        };
        if (!nicFormData.network.trim()) {
            newErrors.network = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.NETWORK_REQUIRED;
        }
        const isNetworkNone = nicFormData.network.toLowerCase() === NETWORK_NONE;
        if (!isNetworkNone) {
            if (!nicFormData.networkAdapterType.trim()) {
                newErrors.networkAdapterType = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.NETWORK_ADAPTER_TYPE_REQUIRED;
            }
            if (!nicFormData.ipMode.trim()) {
                newErrors.ipMode = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.IP_MODE_REQUIRED;
            }
        }
        if (nicFormData.ipMode === 'manual') {
            const { error: ipError, normalized } = validateIpAddress(nicFormData.ipAddress);
            if (ipError) {
                newErrors.ipAddress = ipError;
            }
        }
        if (newErrors.network || newErrors.networkAdapterType || newErrors.ipMode || newErrors.ipAddress || newErrors.ipType) {
            setNicError(newErrors);
            return;
        }
        let updatedOriginalNicData = [...originalNicData];
        if (nicFormData.primaryNic) {
            updatedOriginalNicData = updatedOriginalNicData.map(nic => ({
                ...nic,
                isPrimary: false // Remove primary status from all existing NICs
            }));
        }
        const generateUniqueNicId = () => {
            const existingIds = originalNicData.map(nic => nic.id);
            let newId = 1;
            while (existingIds.includes(newId)) {
                newId++;
            }
            return newId;
        };
        const newNic = {
            id: generateUniqueNicId(),
            connected: nicFormData.connected,
            network: nicFormData.network || 'None',
            macAddress: nicFormData.macAddress,
            networkAdapter: nicFormData.networkAdapterType,
            ipMode: nicFormData.ipMode,
            ipAddress: nicFormData.ipAddress,
            ipType: 'IPV4',
            isPrimary: nicFormData.primaryNic,
            ...(isEditMode && { vcdVmID: "", vmID: "" })
        };
        // Add the new NIC to the updated array
        updatedOriginalNicData = [...updatedOriginalNicData, newNic];
        if (!updatedOriginalNicData.some(nic => nic.isPrimary)) {
            updatedOriginalNicData[0].isPrimary = true;
        }
        setOriginalNicData([...updatedOriginalNicData]);
        setNicFormData({
            network: '',
            networkAdapterType: '',
            ipMode: '',
            ipAddress: '',
            ipType: 'IPV4',
            macAddress: '',
            primaryNic: false,
            connected: true
        });
        setVmFormError(prev => ({
            ...prev,
            atleastoneNic: ''
        }));
        setShowNicForm(false);
    };
    /**
     * This function handles the cancellation of adding a NIC to the table.
     */
    const handleCancelNicToTable = () => {
        setNicError(initialNicError);
        setNicFormData(initialNicFormData);
        setShowNicForm(false);
    };
    /**
 * Check if the form has unsaved changes
 */
    const checkForUnsavedChanges = (): boolean => {
        if (!isEditMode || !originalFormData) return false;
        const currentData = {
            courseDescription: generalDetails.courseDescription,
            courseDuration: generalDetails.courseDuration,
            vmDetails: vmTable
        };
        // Check if any field has changed
        const hasChanges = (
            currentData.courseDescription !== originalFormData.courseDescription ||
            currentData.courseDuration !== originalFormData.duration ||
            JSON.stringify(currentData.vmDetails) !== JSON.stringify(originalFormData.vmDetails)
        );
        return hasChanges;
    };
    const handlePublishClick = () => {
        if (isEditMode && checkForUnsavedChanges()) {
            setShowPublishWarning(true);
        } else {
            saveAndPublishCourse('publish');
        }
    };

    /**
 * Validates that all VMs have unique IPv4 addresses
 * @param payload - The course payload to validate
 * @returns Object with isValid flag and error message if invalid
 */
    const validateUniqueIpAddresses = (payload: any): { isValid: boolean; errorMessage?: string; duplicateIps?: string[] } => {
        const ipAddresses = new Map<string, string[]>(); // Map of IP -> VM Names that use it
        payload.vmDetails.forEach((vm: any) => {
            // Only check the IPv4 field (primary NIC IP address)
            if (vm.IPv4 && vm.IPv4.trim() !== '') {
                if (!ipAddresses.has(vm.IPv4)) {
                    ipAddresses.set(vm.IPv4, []);
                }
                ipAddresses.get(vm.IPv4)!.push(vm.vmName);
            }
        });
        // Find duplicate IPs
        const duplicates = Array.from(ipAddresses.entries()).filter(([ip, vmNames]) => vmNames.length > 1);
        if (duplicates.length > 0) {
            const duplicateIps = duplicates.map(([ip]) => ip);
            const errorMessage = duplicates.length === 1
                ? `${CREATE_COURSE_CONSTANTS.DUPLICATE_IP.ONE_IP} ${duplicateIps[0]}`
                : `${CREATE_COURSE_CONSTANTS.DUPLICATE_IP.MORE_THAN} ${duplicateIps.join(', ')}`;
            return {
                isValid: false,
                errorMessage,
                duplicateIps
            };
        }
        return { isValid: true };
    };
    /**
     * This function handles the save action for the course definition form.
     * @returns 
     */
    const saveAndPublishCourse = (type: string) => {
        setActionType(type as 'draft' | 'publish');
        if (type === 'draft') {
            const formErrors = {
                courseName: '',
                courseDuration: '',
                courseDescription: '',
                templateAssociate: '',
                vAppTemplate: '',
                vAppTemplateName: '',
                atleastonevm: ''
            }
            if (!generalDetails.courseName.trim()) {
                formErrors.courseName = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSENAME_REQUIRED;
            }
            if (!generalDetails.courseDuration || generalDetails.courseDuration === '') {
                formErrors.courseDuration = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.COURSE_DURATION_REQUIRED;
            }
            if (!generalDetails.vAppTemplateName.trim()) {
                formErrors.vAppTemplateName = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.TEMPLATE_NAME_REQUIRED;
            }
            if (templateAssociation === 'existing' && !isEditMode) {
                if (!generalDetails.vAppTemplate.trim()) {
                    formErrors.vAppTemplate = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.TEMPLATE_REQUIRED;
                }
            }
            if (generalDetails.courseName.trim()) {
                const courseNameError = validateCourseName(generalDetails.courseName);
                if (courseNameError) {
                    formErrors.courseName = courseNameError;
                }
            }
            if (generalDetails.courseDescription.trim()) {
                const descriptionError = validateDescription(generalDetails.courseDescription);
                if (descriptionError) {
                    formErrors.courseDescription = descriptionError;
                }
            }
            if (generalDetails.courseDuration) {
                const durationError = validateCourseDuration(generalDetails.courseDuration.toString());
                if (durationError) {
                    formErrors.courseDuration = durationError;
                }
            }
            if (generalDetails.vAppTemplateName.trim()) {
                const templateNameError = validateTemplateName(generalDetails.vAppTemplateName);
                if (templateNameError) {
                    formErrors.vAppTemplateName = templateNameError;
                }
            }
            if (templateAssociation === 'existing') {
                if (isEditMode) {
                    // In edit mode, check tableData length (since selectedVms is auto-populated)
                    if (tableData.length === 0) {
                        formErrors.atleastonevm = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.MIN_ONE_VM;
                        dispatch(showToast({ type: "error", subtitle: formErrors.atleastonevm }));
                    }
                } else {
                    // In create/copy mode, check selected items
                    if (selectedItemsIds.length === 0) {
                        formErrors.atleastonevm = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.MIN_ONE_VM;
                        dispatch(showToast({ type: "error", subtitle: formErrors.atleastonevm }));
                    }
                }
            }
            if (newSelectedItemsIds.length === 0 && templateAssociation === 'new' && vmFormData.creationType === 'fromVm') {
                formErrors.atleastonevm = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.MIN_ONE_VM;
                dispatch(showToast({ type: "error", subtitle: formErrors.atleastonevm }));
            }
            setGeneralDetailsFormError(formErrors);
            if (formErrors.courseName || formErrors.courseDuration || formErrors.courseDescription ||
                formErrors.vAppTemplate || formErrors.vAppTemplateName || formErrors.atleastonevm) {
                return;
            } else {
                const payload = constructCoursePayload();
                if (isEditMode) {
                    const ipValidation = validateUniqueIpAddresses(payload);
                    if (!ipValidation.isValid) {
                        dispatch(showToast({
                            type: "error",
                            title: CREATE_COURSE_CONSTANTS.UPDATECOURSE_VALIDATION.TITLE,
                            subtitle: ipValidation.errorMessage
                        }));
                        return;
                    }
                }
                dispatch(saveUpdateCourseDefinition(payload, isEditMode))
            }

        } else {
            const atleastOneVmPoweredOn = originalFormData && originalFormData.vmDetails && originalFormData.vmDetails.some((vm: any) => vm.powerOn === true);
            if (atleastOneVmPoweredOn) {
                dispatch(showToast(
                    {
                        type: "error",
                        title: CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_TOAST.TITLE,
                        subtitle: CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_TOAST.SUB_TITLE
                    }));
                return;
            }
            const payload = constructCoursePayload();
            const ipValidation = validateUniqueIpAddresses(payload);
            if (!ipValidation.isValid) {
                dispatch(showToast({
                    type: "error",
                    title: CREATE_COURSE_CONSTANTS.PUBLISH_VALIDATION_TOAST.TITLE,
                    subtitle: ipValidation.errorMessage
                }));
                return;
            }
            const publishPayload = {
                CourseId: generalDetails.courseId,
                NewTemplateName: generalDetails.vAppTemplateName,
                RequestedBy: userDetail.userId || '',
            }
            dispatch(publishCourseDefinition(publishPayload))
        }
    }
    /**
     * Constructs the payload for the course creation/update API call.
     * @param type - The type of the course (new or existing).
     * @returns The constructed payload object.
     */
    const constructCoursePayload = () => {
        let vmDetailsArray: any[] = [];
        let vAppTemplateID = null;
        /** CREATE COURSE WITH EXISTING TEMPLATE */
        if (templateAssociation === 'existing' && !isEditMode) {
            vmDetailsArray = Object.values(selectedVms)
                .filter(vm => vm !== undefined)
                .map((vm: any) => {
                    const vmFormDataItem = newVmsList.find(formVm => formVm.id === vm.id);
                    if (vmFormDataItem) {
                        const transformedVmFormDataItem = {
                            ...vmFormDataItem,
                            bootImage: {
                                bootImageId: vmFormDataItem.bootImage || '',
                                bootImageName: vmFormDataItem.bootImageName || ''
                            }
                        };
                        const { bootImageName, ...finalVmFormDataItem } = transformedVmFormDataItem;
                        return finalVmFormDataItem;
                    } else {
                        const ramValue = vm.ram ? parseInt(vm.ram.replace(/[^0-9]/g, '')) : 0;
                        const cpuValue = vm.cpu ? parseInt(vm.cpu.replace(/[^0-9]/g, '')) : 0
                        return {
                            originalvAppTemplateID: generalDetails.vAppTemplate,
                            vmID: vm.id,
                            vmName: vm.vmName,
                            vmDescription: vm.vmDescription,
                            vmUrl: vm.vmURL || '',
                            OSType: vm.osType,
                            OSVer: vm.osVersion,
                            OSVersionId: vm.osVersionID,
                            bootImage: {
                                bootImageId: '',
                                bootImageName: ''
                            },
                            bootSetup: true,
                            RAMValue: ramValue,
                            RAMUnit: vm.ramUnit,
                            CPU: cpuValue,
                            CPUUnit: "cores",
                            Storage: vm.storage,
                            IPv4: vm.ipAddress !== "" ? vm.ipAddress : '',
                            IsPausable: vm.vmPause === 'Yes' ? "true" : "false",
                            IsPowerOn: vm.powerOn ? true : false,
                            nicConfig: []
                        };
                    }
                });
            /** UPDATE COURSE DEFINITION */
        } else if (templateAssociation === 'existing' && isEditMode) {
            vmDetailsArray = vmTable.map((vm: any) => {
                // Check if this VM is newly added in edit mode
                const isNewlyAddedVM = newVmsList.find(newVm => newVm.id === vm.id);
                if (isNewlyAddedVM) {
                    // Use CREATE payload structure for newly added VMs
                    return {
                        originalvAppTemplateID: isNewlyAddedVM.originalvAppTemplateID,
                        vmID: isNewlyAddedVM.vmID,
                        vmName: isNewlyAddedVM.vmName,
                        vmDescription: isNewlyAddedVM.vmDescription,
                        vmUrl: isNewlyAddedVM.vmURL,
                        OSType: isNewlyAddedVM.OSType,
                        OSVer: isNewlyAddedVM.OSVer,
                        bootImage: {
                            bootImageId: isNewlyAddedVM.bootImage || '',
                            bootImageName: isNewlyAddedVM.bootImageName || ''
                        },
                        bootSetup: isNewlyAddedVM.bootSetup || false,
                        bootFirmware: isNewlyAddedVM.bootFirmware ? isNewlyAddedVM.bootFirmware : '',
                        OSVersionId: isNewlyAddedVM.OSVersionId,
                        RAMValue: isNewlyAddedVM.RAMValue,
                        RAMUnit: isNewlyAddedVM.RAMUnit,
                        CPU: isNewlyAddedVM.CPU,
                        CPUUnit: isNewlyAddedVM.CPUUnit || "cores",
                        Storage: isNewlyAddedVM.Storage,
                        IPv4: isNewlyAddedVM.IPv4 || '',
                        IsPausable: isNewlyAddedVM.IsPausable,
                        IsPowerOn: isNewlyAddedVM.IsPowerOn,
                        nicConfig: isNewlyAddedVM.nicConfig ? isNewlyAddedVM.nicConfig.map((nic: any) => ({
                            NICId: nic.NICId || null,
                            IsPrimary: nic.IsPrimary,
                            IsConnected: nic.IsConnected,
                            IPV4: nic.IPModeId === getIpModeId('manual') ? (nic.IPV4 || '') : '',
                            MACId: nic.MACId || null,
                            NetworkId: nic.NetworkId === 0 ? (nicNetwork.find((n: INetworkList) => n.networkValue.toLowerCase() === "none")?.id || 1) : nic.NetworkId,
                            NetworkAdapterTypeId: nic.NetworkAdapterTypeId === 0 ? 1 : nic.NetworkAdapterTypeId,
                            IPModeId: nic.IPModeId || getIpModeId(nic.ipMode || 'None')
                        })) : []
                    };
                }
                const ramValue = vm.ram ? parseInt(vm.ram.replace(/[^0-9]/g, '')) : 0;
                const cpuValue = vm.cpu ? parseInt(vm.cpu.replace(/[^0-9]/g, '')) : 0;
                return {
                    originalvAppTemplateID: vm.originalvAppTemplateID,
                    vmID: vm.vmID,
                    vmName: vm.vmName,
                    vmDescription: vm.vmDescription,
                    vmUrl: vm.vmURL,
                    OSType: vm.osType,
                    OSVer: vm.osVersionValue,
                    OSVersionId: vm.osVersionID,
                    bootSetup: vm.bootSetup || false,
                    bootImage: {
                        bootImageId: vm.bootImage ? vm.bootImage : '',
                        bootImageName: vm.bootImageName ? vm.bootImageName : ''
                    },
                    bootFirmware: vm.bootFirmware ? vm.bootFirmware : '',
                    RAMValue: ramValue,
                    RAMUnit: vm.ramUnit,
                    CPU: cpuValue,
                    CPUUnit: "cores",
                    Storage: `${vm.storage} GB`,
                    IPv4: vm.ipAddress !== "--" ? vm.ipAddress : '',
                    IsPausable: vm.vmPause === 'Yes' ? "true" : "false",
                    IsPowerOn: vm.powerOn,
                    nicConfig: vm.nicConfig.map((nic: any) => ({
                        NICId: nic.NICId && nic.MACId ? nic.NICId : null,
                        IsPrimary: nic.IsPrimary,
                        IsConnected: nic.IsConnected,
                        IPV4: nic.IPModeId === getIpModeId('manual') ? (nic.ipAddress || '') : '',
                        MACId: nic.MACId ? nic.MACId : null,
                        NetworkId: nic.NetworkId === 0 ? (nicNetwork.find((n: INetworkList) => n.networkValue.toLowerCase() === "none")?.id || 1) : nic.NetworkId,
                        NetworkAdapterTypeId: nic.NetworkAdapterTypeId === 0 ? 1 : nic.NetworkAdapterTypeId,
                        IPModeId: nic.IPModeId || getIpModeId(nic.ipMode || 'None')
                    }))
                };
            })
        } else if (templateAssociation === 'new' && !isEditMode) {
            const selectedVmIds = Object.keys(newSelectedVms).filter(id => newSelectedVms[id] !== undefined);
            const selectedVmDetails = newVmsList.filter(vm => selectedVmIds.includes(vm.id.toString()));
            vmDetailsArray = selectedVmDetails.map((vm: any) => {
                return {
                    originalvAppTemplateID: vm.originalvAppTemplateID,
                    vmID: vm.vmID,
                    vmName: vm.vmName,
                    vmDescription: vm.vmDescription,
                    vmUrl: vm.vmURL,
                    OSType: vm.OSType,
                    OSVer: vm.OSVer,
                    bootImage: {
                        bootImageId: vm.bootImage ? vm.bootImage : '',
                        bootImageName: vm.bootImageName ? vm.bootImageName : ''
                    },
                    bootSetup: vm.bootSetup,
                    bootFirmware: vm.bootFirmware ? vm.bootFirmware : '',
                    OSVersionId: vm.OSVersionId,
                    RAMValue: vm.RAMValue,
                    RAMUnit: vm.RAMUnit,
                    CPU: vm.CPU,
                    CPUUnit: vm.CPUUnit,
                    Storage: vm.Storage,
                    IPv4: (vm.IPv4 !== 'Auto-assigned' && vm.IPv4 !== 'None') ? vm.IPv4 : '',
                    IsPausable: vm.IsPausable,
                    IsPowerOn: vm.IsPowerOn,
                    nicConfig: vm.nicConfig ? vm.nicConfig.map((nic: any) => ({
                        NICId: nic.NICId,
                        IsPrimary: nic.IsPrimary,
                        IsConnected: nic.IsConnected,
                        IPV4: nic.IPModeId === getIpModeId('manual') ? (nic.IPV4 || '') : '',
                        MACId: nic.MACId,
                        NetworkId: nic.NetworkId === 0 ? (nicNetwork.find((n: INetworkList) => n.networkValue.toLowerCase() === "none")?.id || 1) : nic.NetworkId,
                        NetworkAdapterTypeId: nic.NetworkAdapterTypeId === 0 ? 1 : nic.NetworkAdapterTypeId,
                        IPModeId: nic.IPModeId || getIpModeId(nic.ipMode || 'None')
                    })) : []
                };
            });
        }
        if (templateAssociation === 'existing') {
            vAppTemplateID = generalDetails.vAppTemplate;
        }
        return {
            CourseName: generalDetails.courseName,
            CourseDescription: generalDetails.courseDescription,
            CourseID: isEditMode ? parseInt(courseId) : 0,
            CourseStage: generalDetails.courseStage,
            LastModifiedDate: new Date().toISOString(),
            LastModifiedBy: userDetail.userId || '',
            Duration: Number(generalDetails.courseDuration),
            UseExistingTemplate: templateAssociation === 'existing' ? true : false,
            vAppTemplateID: vAppTemplateID,
            vAppTemplateName: generalDetails.vAppTemplateName,
            vmDetails: vmDetailsArray
        };
    };
    /**
     * This function handles the save action for the VM creation form.
     * @returns 
     */
    const handleSaveVM = () => {
        const formErrors = {
            vmName: '',
            description: '',
            cpu: '',
            ram: '',
            storage: '',
            osType: '',
            osVersion: '',
            bootImage: '',
            bootFirmware: '',
            existingVm: '',
            atleastoneNic: '',
            atleastonePrimaryNic: '',
            atleastoneVm: ''
        }
        if (!vmFormData.vmName.trim()) {
            formErrors.vmName = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.VM_NAME_REQUIRED
        }
        if (!vmFormData.cpu.trim() && vmFormData.creationType === 'fromVm') {
            formErrors.cpu = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.CPU_REQUIRED;
        }
        if (!vmFormData.ram.trim() && vmFormData.creationType === 'fromVm') {
            formErrors.ram = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_REQUIRED;
        }
        if (!vmFormData.storage.trim() && vmFormData.creationType === 'fromVm') {
            formErrors.storage = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.STORAGE_REQUIRED;
        }
        if (!vmFormData.osType.trim() && vmFormData.creationType === 'fromVm') {
            formErrors.osType = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.OS_TYPE_REQUIRED
        }
        if (!vmFormData.osVersion.trim() && vmFormData.creationType === 'fromVm') {
            formErrors.osVersion = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.OS_VERSION_REQUIRED
        }
        if (!vmFormData.bootImage.trim() && vmFormData.creationType === 'fromVm' && !vmFormData.isFromAPI) {
            formErrors.bootImage = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.BOOT_IMAGE_REQUIRED
        }
        if (!vmFormData.bootFirmware.trim() && vmFormData.creationType === 'fromVm' && !vmFormData.isFromAPI) {
            formErrors.bootFirmware = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.BOOT_FIRMWARE_REQUIRED
        }
        if (vmFormData.vmName.trim()) {
            const vmNameError = validateVmName(vmFormData.vmName);
            if (vmNameError) {
                formErrors.vmName = vmNameError;
            }
        }
        if (vmFormData.description.trim()) {
            const descriptionError = validateVmDescription(vmFormData.description);
            if (descriptionError) {
                formErrors.description = descriptionError;
            }
        }
        if (vmFormData.storage.trim() && vmFormData.creationType === 'fromVm') {
            const storageError = validateVmStorage(vmFormData.storage);
            if (storageError) {
                formErrors.storage = storageError;
            }
        }
        if (vmFormData.ram.trim() && vmFormData.creationType === 'fromVm') {
            const ramError = validateVmRam(vmFormData.ram, vmFormData.ramUnit);
            if (ramError) {
                formErrors.ram = ramError;
            }
        }
        if (vmFormData.creationType === 'fromVm') {
            const currentNicCount = nicTableData.length;
            if (currentNicCount === 0 || originalNicData.length === 0) {
                formErrors.atleastoneNic = CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.ATLEAST_ONE_NIC_REQUIRED;
                dispatch(showToast({ type: "error", subtitle: formErrors.atleastoneNic }));
                setVmFormError(formErrors);
                return;
            }
        }
        setVmFormError(formErrors);
        if (formErrors.vmName || formErrors.description || formErrors.cpu || formErrors.ram ||
            formErrors.storage || formErrors.osType || formErrors.osVersion || formErrors.bootImage ||
            formErrors.atleastoneNic || formErrors.atleastoneVm || formErrors.atleastonePrimaryNic || formErrors.bootFirmware) {
            return;
        }
        /** EDIT MODE - Derive context from state */
        const isEditingVmInEditMode = isEditMode && !!vmFormData.vmId;
        const isVmInNewVmsList = !!newVmsList.find(vm => String(vm.id) === String(vmFormData.vmId));
        const isEditingNewVmInEditMode = isEditingVmInEditMode && isVmInNewVmsList;

        /** EDIT MODE - Editing an EXISTING VM from API (already in DB) */
        if (isEditingVmInEditMode && !isEditingNewVmInEditMode) {
            const existingVM = vmTable.find(row => String(row.id) === String(vmFormData.vmId));
            if (existingVM) {
                let obj = tableData.find((vm: IVMTable) => String(vm.id) === String(vmFormData.vmId));
                if (!obj) {
                    dispatch(showToast({ type: "error", subtitle: "Unable to update VM. Please try again." }));
                    return;
                }
                const updatedVM: IVMTable = {
                    ...existingVM,
                    vmName: vmFormData.vmName,
                    cpu: vmFormData.cpu,
                    ram: vmFormData.ram,
                    ramUnit: vmFormData.ramUnit,
                    storage: vmFormData.storage,
                    vmPause: vmFormData.vmAutoPause ? 'Yes' : 'No',
                    vmDescription: vmFormData.description,
                    powerOn: vmFormData.powerOn,
                    ipAddress: originalNicData.find(nic => nic.isPrimary)?.ipAddress || '--',
                    nicConfig: originalNicData.map(nic => {
                        let networkId;
                        let networkAdapterTypeId;
                        const networkLower = nic.network.toLowerCase();
                        const networkAdapterLower = nic.networkAdapter.toLowerCase();
                        if (networkLower === "none" || networkLower === "default") {
                            networkId = 1;
                        } else {
                            networkId = nicNetwork.find((network: INetworkList) => network.networkValue.toLowerCase() === networkLower)?.id || 1;
                        }
                        if (networkAdapterLower === "none") {
                            networkAdapterTypeId = 1;
                        } else {
                            networkAdapterTypeId = nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.naTypeValue.toLocaleLowerCase() === networkAdapterLower)?.id || 1;
                        }
                        return {
                            NICId: nic.id,
                            IsPrimary: nic.isPrimary,
                            IsConnected: nic.connected,
                            IPV4: nic.ipMode?.toLowerCase() === 'manual' ? nic.ipAddress : '',
                            ipAddress: nic.ipAddress,
                            MACId: nic.macAddress,
                            NetworkId: networkId,
                            NetworkAdapterTypeId: networkAdapterTypeId,
                            IPModeId: getIpModeId(nic.ipMode)
                        }
                    })
                };
                setTableData(prevData => prevData.map(vm => String(vm.id) === String(vmFormData.vmId) ? updatedVM : vm));
                setVmTable(prevData => prevData.map(vm => String(vm.id) === String(vmFormData.vmId) ? updatedVM : vm));
                closeAndReset(false, false);
            } else {
                dispatch(showToast({ type: "error", subtitle: "Unable to update VM. Please try again." }));
            }
        }
        /** EDIT MODE - Editing a NEWLY CREATED VM in edit mode (not yet in DB) */
        else if (isEditingNewVmInEditMode) {
            // Update the VM in newVmsList
            const updatedVmObj = {
                ...newVmsList.find(vm => String(vm.id) === String(vmFormData.vmId)),
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                OSType: vmFormData.osType,
                OSVer: vmFormData.osVersion,
                bootSetup: vmFormData.bootSetup,
                bootImage: vmFormData.bootImage,
                bootImageName: isoFileList.find((image: any) => image.mediaId === vmFormData.bootImage)?.name || '',
                bootFirmware: vmFormData.bootFirmware.toLowerCase(),
                RAMValue: parseInt(vmFormData.ram),
                RAMUnit: vmFormData.ramUnit,
                CPU: Number(vmFormData.cpu),
                Storage: `${vmFormData.storage} GB`,
                IPv4: originalNicData.find(nic => nic.isPrimary)?.ipAddress || null,
                IsPausable: vmFormData.vmAutoPause ? "true" : "false",
                IsPowerOn: vmFormData.powerOn,
                nicConfig: originalNicData.map(nic => ({
                    NICId: null,
                    IsPrimary: nic.isPrimary,
                    IsConnected: nic.connected,
                    IPV4: nic.ipMode?.toLowerCase() === 'manual' ? nic.ipAddress : '',
                    MACId: null,
                    NetworkId: nic.network.toLowerCase() === "default" || nic.network.toLowerCase() === "none" ? 1 : nicNetwork.find((network: INetworkList) => network.networkValue.toLocaleLowerCase() === nic.network.toLowerCase())?.id || 1,
                    NetworkAdapterTypeId: (nic.networkAdapter.toLowerCase() === "none" ? 1 : nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.naTypeValue.toLocaleLowerCase() === nic.networkAdapter.toLowerCase())?.id) || 1,
                    IPModeId: getIpModeId(nic.ipMode)
                }))
            };
            let osType = osListReducer.find((os: IOSTypes) => os.osTypeName === vmFormData.osType || os.osTypeID === Number(vmFormData.osType))?.osTypeName || '';
            if (osType) {
                updatedVmObj.OSType = osType;
            }
            let osVersion = osVersions.find((version: IVersion) => version.osVersionName === vmFormData.osVersion || version.osVersionValue === vmFormData.osVersion)?.osVersionValue || '';
            if (osVersion) {
                updatedVmObj.OSVer = osVersion;
            }
            setNewVmsList(prevData => prevData.map(vm => String(vm.id) === String(vmFormData.vmId) ? updatedVmObj : vm));
            let obj = {
                id: vmFormData.vmId,
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                powerOn: vmFormData.powerOn,
                vmURL: "",
                osType: "",
                osVersion: "",
                bootSetup: vmFormData.bootSetup,
                bootImage: vmFormData.bootImage,
                bootImageName: isoFileList.find((image: any) => image.mediaId === vmFormData.bootImage)?.name || '',
                bootFirmware: vmFormData.bootFirmware.toLowerCase(),
                ram: vmFormData.ram,
                ipAddress: originalNicData.find(nic => nic.isPrimary)?.ipAddress || '--',
                cpu: vmFormData.cpu,
                storage: vmFormData.storage,
                vmPause: vmFormData.vmAutoPause ? "Yes" : "No",
                originalvAppTemplateID: "",
                osVersionID: "",
                ramUnit: vmFormData.ramUnit,
                isNewlyAdded: isEditMode, // Mark if added in edit mode
                isFromAPI: false, // Flag to identify if VM came from API
                isFromTemplate: false,
                nicConfig: originalNicData.map(nic => {
                    let networkId;
                    let networkAdapterTypeId;
                    const networkLower = nic.network.toLowerCase();
                    const networkAdapterLower = nic.networkAdapter.toLowerCase();
                    if (networkLower === "none") {
                        networkId = 0;
                    } else if (networkLower === "default") {
                        networkId = 1;
                    } else {
                        networkId = nicNetwork.find((network: INetworkList) => network.networkValue.toLowerCase() === networkLower)?.id || 0;
                    }
                    if (networkAdapterLower === "none") {
                        networkAdapterTypeId = 0;
                    } else {
                        networkAdapterTypeId = nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.naTypeValue.toLocaleLowerCase() === networkAdapterLower)?.id;
                    }
                    return {
                        NICId: nic.id,
                        IsPrimary: nic.isPrimary,
                        IsConnected: nic.connected,
                        IPV4: nic.ipMode?.toLowerCase() === "manual" ? nic.ipAddress : "",
                        ipAddress: nic.ipAddress,
                        MACId: nic.macAddress,
                        NetworkId: networkId,
                        NetworkAdapterTypeId: networkAdapterTypeId,
                        IPModeId: getIpModeId(nic.ipMode)
                    }
                })
            };
            let selectedOsType = osListReducer.find((os: IOSTypes) =>
                os.osTypeName === vmFormData.osType || os.osTypeID === Number(vmFormData.osType)
            )?.osTypeName || '';
            if (selectedOsType) {
                obj.osType = selectedOsType;
            }
            let selectedOsVersion = osVersions.find((version: IVersion) => version.osVersionName === vmFormData.osVersion || version.osVersionValue === vmFormData.osVersion)?.osVersionName || '';
            if (selectedOsVersion) {
                obj.osVersion = selectedOsVersion;
            }
            setTableData(prevData => prevData.map(vm => String(vm.id) === String(vmFormData.vmId) ? obj : vm));
            setVmTable(prevData => prevData.map(vm => String(vm.id) === String(vmFormData.vmId) ? obj : vm));
            closeAndReset(false, true);
        }
        /** CREATE MODE - CREATE NEW VM FROM TEMPLATE */
        else if (vmFormData.creationType === 'fromTemplate' && vmFormData.vmId === "") {
            const templateData = selectedTemplateData;
            const vmDetails = templateData.vmDetails;
            let obj = {
                id: vmDetails.vmId,
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                /** START - TO SHOW IN VIEW PAGE POPUP */
                vAppTemplateName: templateData.vAppTemplateName,
                vAppTempVmname: vmDetails.vmName,
                vAppTempAutoPause: vmDetails.isPausable === "true" ? "Yes" : "No",
                vAppTempVmIP: vmDetails.ipAddress,
                /** END - TO SHOW IN VIEW PAGE POPUP */
                powerOn: vmDetails.powerOn ? vmDetails.powerOn : '--',
                vmURL: vmDetails.vmURL,
                osType: vmDetails.osType ? vmDetails.osType : '--',
                osVersion: vmDetails.osVer ? vmDetails.osVer : '--',
                ram: vmDetails.ramValue.replace(/[^0-9]/g, '') ? vmDetails.ramValue.replace(/[^0-9]/g, '') : '--',
                ramUnit: vmDetails.ramUnit,
                isNewlyAdded: isEditMode, // Mark if added in edit mode
                isFromAPI: false, // Flag to identify if VM came from API
                isFromTemplate: true,
                ipAddress: vmDetails.ipAddress ? vmDetails.ipAddress : '--',
                cpu: vmDetails.cpu ? vmDetails.cpu : '--',
                storage: vmDetails.storage.replace(/[^0-9]/g, '') ? vmDetails.storage.replace(/[^0-9]/g, '') : '--',
                vmPause: vmFormData.vmAutoPause ? "Yes" : "No",
                originalvAppTemplateID: "",
                osVersionID: vmDetails.osVersionId,
                nicConfig: []
            };
            let selectedVmObj = {
                originalvAppTemplateID: templateData.hrefVappTemplateId,
                vmID: vmDetails.vmId,
                id: vmDetails.vmId,
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                /** START - TO SHOW IN VIEW PAGE POPUP */
                vAppTemplateName: templateData.vAppTemplateName,
                vAppTempVmname: vmDetails.vmName,
                vAppTempAutoPause: vmDetails.isPausable === "true" ? "Yes" : "No",
                vAppTempVmIP: vmDetails.ipAddress,
                /** END - TO SHOW IN VIEW PAGE POPUP */
                vmURL: vmDetails.vmURL,
                OSType: vmDetails.osType,
                OSVer: vmDetails.osVer,
                OSVersionId: vmDetails.osVersionId,
                RAMValue: vmDetails.ramValue.replace(/[^0-9]/g, '') ? parseInt(vmDetails.ramValue.replace(/[^0-9]/g, '')) : 0,
                RAMUnit: vmDetails.ramUnit,
                isNewlyAdded: isEditMode, // Mark if added in edit mode
                isFromAPI: false, // Flag to identify if VM came from API
                isFromTemplate: true,
                CPUUnit: "cores",
                Storage: vmDetails.storage,
                ipAddress: vmDetails.ipAddress,
                CPU: Number(vmDetails.cpu),
                IPv4: vmDetails.ipAddress,
                IsPausable: vmFormData.vmAutoPause ? "true" : "false",
                IsPowerOn: vmFormData.powerOn,
                nicConfig: []
            };
            if (templateAssociation === 'new') {
                setNewTableData(prevData => [...prevData, obj]);
                setNewVmTable(prevData => [...prevData, obj]);
            } else if (templateAssociation === 'existing') {
                setTableData(prevData => [...prevData, obj]);
                setVmTable(prevData => [...prevData, obj]);
            }
            // Constructing the VM object and adding it to the list
            setNewVmsList(prevData => [...prevData, selectedVmObj]);
            closeAndReset(false, true);
        }
        /** CREATE MODE - CREATE NEW VM FROM NEW VM */
        else if (vmFormData.creationType === 'fromVm' && vmFormData.vmId === "") {
            const generateUniqueId = () => {
                const currentId = vmIdCounter;
                setVmIdCounter(prev => prev + 1);
                return currentId.toString();
            };
            const sharedVmId = generateUniqueId();
            let obj = {
                id: sharedVmId,
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                powerOn: vmFormData.powerOn,
                vmURL: "",
                osType: "",
                osVersion: "",
                bootSetup: vmFormData.bootSetup,
                bootImage: vmFormData.bootImage,
                bootImageName: vmFormData.bootImageName,
                bootFirmware: vmFormData.bootFirmware.toLowerCase(),
                ram: vmFormData.ram,
                ipAddress: originalNicData.find(nic => nic.isPrimary)?.ipAddress || '--',
                cpu: vmFormData.cpu,
                storage: vmFormData.storage,
                vmPause: vmFormData.vmAutoPause ? "Yes" : "No",
                originalvAppTemplateID: "",
                osVersionID: "",
                ramUnit: vmFormData.ramUnit,
                isNewlyAdded: isEditMode, // Mark if added in edit mode
                isFromAPI: false, // Flag to identify if VM came from API
                isFromTemplate: false,
                nicConfig: originalNicData.map(nic => {
                    let networkId;
                    let networkAdapterTypeId;
                    const networkLower = nic.network.toLowerCase();
                    const networkAdapterLower = nic.networkAdapter.toLowerCase();
                    if (networkLower === "none") {
                        networkId = 0;
                    } else if (networkLower === "default") {
                        networkId = 1;
                    } else {
                        networkId = nicNetwork.find((network: INetworkList) => network.networkValue.toLowerCase() === networkLower)?.id || 0;
                    }
                    if (networkAdapterLower === "none") {
                        networkAdapterTypeId = 0;
                    } else {
                        networkAdapterTypeId = nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.naTypeValue.toLocaleLowerCase() === networkAdapterLower)?.id;
                    }
                    return {
                        NICId: nic.id,
                        IsPrimary: nic.isPrimary,
                        IsConnected: nic.connected,
                           IPV4: nic.ipMode?.toLowerCase() === 'manual' ? nic.ipAddress : '',
                        ipAddress: nic.ipAddress,
                        MACId: nic.macAddress,
                        NetworkId: networkId,
                        NetworkAdapterTypeId: networkAdapterTypeId,
                        IPModeId: getIpModeId(nic.ipMode)
                    }
                })
            };
            let selectedOsType = osListReducer.find((os: IOSTypes) => os.osTypeID === Number(vmFormData.osType))?.osTypeName || '';
            if (selectedOsType) {
                obj.osType = selectedOsType;
            }
            let selectedOsVersion = osVersions.find((version: IVersion) => version.osVersionValue === vmFormData.osVersion)?.osVersionName || '';
            if (selectedOsVersion) {
                obj.osVersion = selectedOsVersion;
            }
            let selectedVmObj = {
                originalvAppTemplateID: null,
                vmID: null,
                id: sharedVmId,
                vmName: vmFormData.vmName,
                vmDescription: vmFormData.description,
                newVMName: vmFormData.vmName,
                newVmDescription: vmFormData.description,
                vmURL: null,
                OSType: obj.osType,
                OSVer: vmFormData.osVersion,
                bootSetup: vmFormData.bootSetup,
                bootImage: vmFormData.bootImage,
                bootImageName: vmFormData.bootImageName,
                bootFirmware: vmFormData.bootFirmware.toLowerCase(),
                OSVersionId: osVersions.find((version: IVersion) => version.osVersionValue.toLowerCase() === vmFormData.osVersion.toLowerCase())?.osVersionID || null,
                RAMValue: parseInt(vmFormData.ram),
                RAMUnit: vmFormData.ramUnit,
                CPU: Number(vmFormData.cpu),
                CPUUnit: "cores",
                Storage: `${vmFormData.storage} GB`,
                ipAddress: originalNicData.find(nic => nic.isPrimary)?.ipAddress || null,
                IPv4: originalNicData.find(nic => nic.isPrimary)?.ipAddress || null,
                IsPausable: vmFormData.vmAutoPause ? "true" : "false",
                IsPowerOn: vmFormData.powerOn,
                isNewlyAdded: isEditMode, // Mark if added in edit mode
                isFromAPI: false, // Flag to identify if VM came from API
                isFromTemplate: false,
                nicConfig: originalNicData.map(nic => ({
                    NICId: null,
                    IsPrimary: nic.isPrimary,
                    IsConnected: nic.connected,
                    IPV4: nic.ipMode?.toLowerCase() === 'manual' ? nic.ipAddress : '',
                    MACId: null,
                    NetworkId: (nic.network.toLowerCase() === "default" ? 1 : nicNetwork.find((network: INetworkList) => network.networkValue.toLocaleLowerCase() === nic.network.toLowerCase())?.id) || 1,
                    NetworkAdapterTypeId: (nic.networkAdapter.toLowerCase() === "none" ? 1 : nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.naTypeValue.toLocaleLowerCase() === nic.networkAdapter.toLowerCase())?.id) || 1,
                    IPModeId: getIpModeId(nic.ipMode)
                }))
            };
            if (templateAssociation === 'new') {
                obj.ram = `${obj.ram} ${obj.ramUnit}`;
                obj.cpu = Number(obj.cpu) === 1 ? `${obj.cpu} Core` : `${obj.cpu} Cores`;
                obj.storage = `${vmFormData.storage} GB`;
                setNewTableData(prevData => [...prevData, obj]);
                setNewVmTable(prevData => [...prevData, obj]);
            } else if (templateAssociation === 'existing') {
                setTableData(prevData => [...prevData, obj]);
                setVmTable(prevData => [...prevData, obj]);
            }
            // Constructing the VM object and adding it to the list
            setNewVmsList(prevData => [...prevData, selectedVmObj]);
            closeAndReset(false, true);
        }
    }
    const validateVmName = (name: string): string => {
        if (!name.trim()) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.VM_NAME_REQUIRED
        }
        if (name.length > 15) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.VM_NAME_LENGTH;
        }
        const validCharsRegex = /^[a-zA-Z0-9-]+$/;
        if (!validCharsRegex.test(name)) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.ONLY_LETTERS;
        }
        if (/^\d+$/.test(name)) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.ONLY_DIGITS;
        }
        if (name.endsWith('-')) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.NO_HYPHEN;
        }
        return '';
    };
    /**
     * This function validates the RAM input for the VM creation form.
     * @param value 
     * @returns 
     */
    const validateVmDescription = (description: string): string => {
        if (description.length > 250) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.ERROR;
        } else if (containsHTMLOrScript(description)) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.ELEMENT_ERROR;
        } else if (description.trim() && !/^[a-zA-Z0-9\s,.\-_]+$/.test(description)) {
            return CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.DESCRIPTION.INVALID_CHARACTERS;
        }
        return '';
    };
    /**
 * This function validates the RAM input for the VM creation form.
 * @param value 
 * @returns 
 */
    const validateVmRam = (ramValue: string, ramUnit: string): string => {
        if (!ramValue.trim()) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_REQUIRED;
        }
        const numValue = Number(ramValue);
        if (numValue <= 0) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.GREATERTHAN_ZERO
        }
        if (ramUnit === 'GB' && numValue > CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_MAX_GB) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_MAX_128GB;
        }
        if (ramUnit === 'MB' && numValue > CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_MAX_MB) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.RAM_MAX_131072MB;
        }
        if (numValue % 4 !== 0 && ramUnit === 'MB') {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.MUST_MULTIPLE_OF_FOUR;
        }
        return '';
    };
    /**
     * This function validates the storage input for the VM creation form.
     * @param value 
     * @returns 
     */
    const validateVmStorage = (value: string): string => {
        if (!value.trim()) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.STORAGE_REQUIRED;
        }
        const numValue = Number(value);
        if (numValue <= 0) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.STORAGE_GREATERTHAN_ZERO;
        }
        if (numValue > 1024) {
            return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.STORAGE_MAX_1TB;
        }
        // Edit mode validation - prevent reducing storage
        if (isEditMode && originalVmData?.storage) {
            const originalStorageValue = Number(originalVmData.storage.replace(/[^0-9]/g, ''));
            if (numValue < originalStorageValue) {
                return CREATE_COURSE_CONSTANTS.VALIDATION_MESSAGES.STORAGE_CANNOT_REDUCE;
            }
        }
        return '';
    };
    /**
     * This function handles the changes in the general details form fields.
     * It updates the state for general details and validates the input values.
     * @param field 
     * @param value 
     */
    const handleGenDetailForm = (field: 'courseName' | 'description' | 'courseDuration' | 'templateAssociate' | 'vAppTemplate' | 'vAppTemplateName', value: string) => {
        if (field === 'courseName') {
            const courseNameError = validateCourseName(value);
            setGeneralDetails(prev => ({
                ...prev,
                courseName: value
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                courseName: courseNameError
            }));
        } else if (field === 'description') {
            const descError = validateDescription(value);
            setGeneralDetails(prev => ({
                ...prev,
                courseDescription: value
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                courseDescription: descError
            }));
        } else if (field === 'courseDuration') {
            const numValue = value.replace(/[^0-9]/g, '');
            const durationValue = numValue === '' ? null : Number(numValue);
            const durationError = validateCourseDuration(numValue);
            setGeneralDetails(prev => ({
                ...prev,
                courseDuration: durationValue
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                courseDuration: durationError
            }));
        } else if (field === 'templateAssociate') {
            setTemplateAssociation(value as 'existing' | 'new');
            if (value === 'new') {
                setGeneralDetails(prev => ({
                    ...prev,
                    vAppTemplate: '',
                    vAppTemplateName: ''
                }));
                /** Resetting the new VM lists and table*/
                setNewVmsList([]);
                setNewTableData([]);
                setNewVmTable([]);
            }
            setGeneralDetails(prev => ({
                ...prev,
                [field]: value
            }));
        } else if (field === 'vAppTemplate' && value) {
            setSelectedVms({});
            setGeneralDetails(prev => ({
                ...prev,
                [field]: value
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                [field]: ''
            }));
            const obj = listofvAppTemplatesDropDown.find((v: any) => v.id.toString() === value)
            if (obj && Object.keys(obj).length) {
                dispatch(getVmDetails(obj.id, 1, 30));
            }
        } else if (field === 'vAppTemplateName') {
            const templateNameError = validateTemplateName(value);
            setGeneralDetails(prev => ({
                ...prev,
                [field]: value
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                vAppTemplateName: templateNameError
            }));
        } else {
            setGeneralDetails(prev => ({
                ...prev,
                [field]: value
            }));
            setGeneralDetailsFormError(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    }
    /**
     * Create a function to handle changes in the VM form fields.   
     * @param field 
     * @param value 
     */
    const handleVMFormChange = (field: keyof IVMFormFields, value: any) => {
        if (field === 'creationType') {
            setVmFormError(prev => ({
                ...prev,
                vmName: '',
                description: '',
                cpu: '',
                ram: '',
                storage: '',
                osType: '',
                osVersion: '',
                bootImage: '',
                bootFirmware: '',
                existingVm: '',
                atleastoneNic: '',
                atleastonePrimaryNic: '',
                atleastoneVm: ''
            }));
            if (value === 'fromTemplate') {
                dispatch(getAllvAppTemplatesAndVms(1, 15))
            }
            setVMAssociation(value as 'fromVm' | 'fromTemplate');
        }
        if (field === 'vmName') {
            const nameError = validateVmName(value as string);
            setVmFormData(prev => ({
                ...prev,
                vmName: value
            }));
            setVmFormError(prev => ({
                ...prev,
                vmName: nameError
            }));
        } else if (field === 'ram') {
            setVmFormData(prev => ({
                ...prev,
                ram: value
            }));
            const ramError = validateVmRam(value, vmFormData.ramUnit);
            setVmFormError(prev => ({
                ...prev,
                ram: ramError
            }));
        } else if (field === 'ramUnit') {
            setVmFormData(prev => ({
                ...prev,
                ramUnit: value
            }));
            const ramError = validateVmRam(vmFormData.ram, value);
            setVmFormError(prev => ({
                ...prev,
                ram: ramError
            }));
        } else if (field === 'description') {
            const descError = validateVmDescription(value);
            setVmFormData(prev => ({
                ...prev,
                description: value
            }));
            setVmFormError(prev => ({
                ...prev,
                description: descError
            }));
        } else if (field === 'storage') {
            const numericValue = value.replace(/[^0-9]/g, '');
            setVmFormData(prev => ({
                ...prev,
                storage: numericValue
            }));
            const storageError = validateVmStorage(numericValue);
            setVmFormError(prev => ({
                ...prev,
                storage: storageError
            }));

        } else if (field === 'osType') {
            setAvailableOsVersions([]);
            setVmFormData(prev => ({
                ...prev,
                [field]: value,
                osVersion: ''
            }));
            setVmFormError(prev => ({
                ...prev,
                osType: '',
            }));
            dispatch(getosVersionsList(value as string));
        } else {
            setVmFormData(prev => ({
                ...prev,
                [field]: value
            }));
            setVmFormError(prev => ({
                ...prev,
                [field]: ''
            }));
        }
    };
    /**
     * This function handles the cancel action for the course creation.
     */
    const handleContinueWithoutSaving = () => {
        setShowCancelConfirmation(false);
        // Close COURSE-SPECIFIC connection
        closeConnection(signalRConnection, HubConnectionState, dispatch);
        isInitialLoad.current = false;
        if (confirmationSource === 'cancel') {
            dispatch(showToast({
                type: "warning",
                title: isEditMode ? CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.UPDATE_TOAST : CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.CREATE_TOAST,
                subtitle: CREATE_COURSE_CONSTANTS.CANCEL_VM_MODAL.SUBTOAST
            }));

            setTimeout(() => {
                navigate('/academy/viewCourseTemplates');
            }, 2000);
        } else {
            navigate('/academy/viewCourseTemplates');
        }
        setConfirmationSource(null);
        dispatch(resetCourseDefData());
    }
    /**
     * This function handles the search input change.
     * @param e 
     */
    const handleSearchChange = (e: any) => {
        const query = e.target.value || '';
        setSearchQuery(query);
        filterData(filterType, query.trim());
    };
    /**
     * This function handles the change in filter type.
     * @param e 
     */
    const handleFilterTypeChange = (e: any) => {
        if (!e || !e.target) return;
        const value = e.target.value;
        if (value) {
            setFilterType(value);
            filterData(value, searchQuery);
        }
    };
    const filterData = (type: string, query: string) => {
        if (!query || !query.trim()) {
            setVmTable(tableData);
            return;
        }

        const lowercasedQuery = query.toLowerCase();
        let filtered = [];

        switch (type) {
            case 'Name':
                filtered = tableData.filter(item =>
                    item.vmName && item.vmName.toLowerCase().includes(lowercasedQuery)
                );
                break;
            case 'OS Type':
                filtered = tableData.filter(item =>
                    item.osType && item.osType.toLowerCase().includes(lowercasedQuery)
                );
                break;
            default:
                filtered = tableData;
        }
        setVmTable(filtered);
    };

    const getFilteredTemplates = () => {
        if (!templateSearchQuery || !templateSearchQuery.trim()) {
            return listofvAppTemplatesDropDown;
        }
        const query = templateSearchQuery.trim().toLowerCase();
        return listofvAppTemplatesDropDown.filter(template => template.name.toLowerCase().includes(query)
        );
    };
    /**
     * This function handles the edit action for a VM.
     * @param vmData 
     */
    const handleViewVM = (vmData: any) => {
        setViewVmDetailsData(vmData);
        setShowViewVmDetailsModal(true);
    }
    /**
     * This function handles the mount ISO action for a VM and shows the MountISOComponent.
     * @param isMounted 
     * @param vmDetails 
     */
    const handleMountIsoForVM = (isMounted: boolean, vmDetails: any) => {
        if (vmDetails && vmDetails.vcdVmID) {
            setSelectedVmForPowerOff(vmDetails.vcdVmID);
        } else {
            setSelectedVmForPowerOff(null);
        }
        setShowMountISOComponent(isMounted);
    }
    /**
     * This function handles the unmount ISO action for a VM and shows the confirmation modal.
     * @param vmDetails 
     */
    const handleUnMountIsoForVM = (vmDetails: any) => {
        if (vmDetails && vmDetails.vcdVmID) {
            setSelectedVmForPowerOff(vmDetails.vcdVmID);
        }
        setShowUnMountISOConfirmation(true);
    }
    /**
     * This function confirms the unmount ISO action for a VM after user confirmation in the modal.
     */
    const handleConfirmUnMountISO = () => {
        if (selectedVmForPowerOff) {
            dispatch(unMountISOFile({
                vmId: [`vm-${selectedVmForPowerOff}`],
                authorization: localStorage.getItem("access_token"),
                siteId: config?.SITE_ID,
                orgId: generalDetails?.courseOrgId,
                tenantId: config?.ACADEMY_TENANT_ID, // Tenant ID
            }));
        }
        setShowUnMountISOConfirmation(false);
        setSelectedVmForPowerOff(null);
    }

    /**
     * This function handles the power on action for a VM.
     * @param vmDetails 
     */
    const handleVmPowerOn = (vmDetails: any) => {
        dispatch(
            vmPowerOnOff({
                vmId: `vm-${vmDetails.vcdVmID}`,
                authorization: localStorage.getItem("access_token"),
                siteId: config?.SITE_ID,
                courseSiteId: generalDetails?.siteId,
                orgId: config?.ACADEMY_TENANT_ID, // Tenant ID
                mode: 'on'
            }),
        );
    }
    /**
     * This function handles the power off action for a VM and shows the confirmation modal.
     * @param show 
     * @param data 
     */
    const handleVmPowerOff = (show: boolean, data: any) => {
        setSelectedVmNameForPowerOff(data.vmName);
        setSelectedVmForPowerOff(data.vcdVmID);
        setPowerOffConfirmation(show);
    }
    /**
     * This function confirms the power off action for a VM after user confirmation in the modal.
     */
    const handleConfirmPowerOff = () => {
        dispatch(
            vmPowerOnOff({
                vmId: `vm-${selectedVmForPowerOff}`,
                authorization: localStorage.getItem("access_token"),
                siteId: config?.SITE_ID,
                courseSiteId: generalDetails?.siteId,
                orgId: config?.ACADEMY_TENANT_ID, // Tenant ID
                mode: 'off'
            }),
        );
        setPowerOffConfirmation(false);
        setSelectedVmNameForPowerOff('');
        setSelectedVmForPowerOff(null);
    }
    /**
    /**
     * This function handles the edit action for a VM.
     * @param vmData 
     */
    const handleEditVM = (vmData: any) => {
        let derivedVmAssociation: 'fromVm' | 'fromTemplate' = 'fromVm';
        const vmPowerStatus = getVmPowerStatus(vmData);
        const staticNetworkList = [{ id: 0, name: "None" }, { id: 1, name: "default" }]
        const staticNetowrkAdapter = [{ id: 0, name: "None" }, { id: 1, name: "VMXNET3" }];
        setSelectedVmId(vmData.id);
        setShowPowerOn(vmData.isFromAPI ? false : true);
        setVmPowerOnStatus(vmPowerStatus);
        if (!vmData.isNewlyAdded) {
            // Store the original VM data when response comes from API
            setOriginalVmData(vmData);
        }
        if (vmData.isNewlyAdded) {
            // Check if this VM was created from a template
            const vmFromList = newVmsList.find(vm => vm.id === vmData.id);
            if (vmFromList?.originalvAppTemplateID && vmFromList.originalvAppTemplateID !== null) {
                derivedVmAssociation = 'fromTemplate';
            }
        }
        setVMAssociation(derivedVmAssociation);
        setVmFormData(prevState => ({
            ...prevState,
            vmId: vmData.id,
            vmName: vmData.vmName,
            description: vmData.vmDescription,
            isFromAPI: vmData.isFromAPI,
            isNewlyAdded: vmData.isNewlyAdded,
            cpu: vmData.cpu,
            ram: vmData.ram,
            ramUnit: vmData.ramUnit,
            storage: vmData.storage,
            osType: vmData.osType,
            osVersion: vmData.osVersion,
            bootImage: vmData.bootImage,
            bootFirmware: vmData.bootFirmware === "efi" ? "EFI" : vmData.bootFirmware === "bios" ? "BIOS" : "",
            bootSetup: vmData.bootSetup,
            vmAutoPause: vmData.vmPause === 'Yes' ? true : false,
            powerOn: vmData.powerOn,
        }));
        if (vmData.nicConfig && Array.isArray(vmData.nicConfig)) {
            const originalNics = vmData.nicConfig.map((nic: any) => ({
                id: nic.NICId,
                connected: nic.IsConnected,
                network: vmData.isNewlyAdded ? staticNetworkList.find(obj => obj.id === nic.NetworkId)?.name : nicNetwork.find((network: INetworkList) => network.id === nic.NetworkId)?.networkValue,
                networkAdapter: vmData.isNewlyAdded ? staticNetowrkAdapter.find(obj => obj.id === nic.NetworkAdapterTypeId)?.name : nicNetworkAdapterType.find((adapter: INetworkAdapter) => adapter.id === nic.NetworkAdapterTypeId)?.naTypeValue,
                ipMode: nicIpModes.find((mode: INicIPModes) => mode.id === nic.IPModeId)?.ipModeValue,
                ipAddress: nic.ipAddress,
                ipType: nic.IPV4,
                isPrimary: nic.IsPrimary,
                macAddress: nic.MACId,
            }));
            setOriginalNicData(originalNics);
        }
        setCreateorEditVm(true);
    };

    const deleteVmFromExitingTemplateTable = (vmId: string) => {
        if (vmTable.length <= 1) {
            dispatch(showToast({
                type: "warning",
                title: "Cannot Delete VM",
                subtitle: "At least one VM is required for the course."
            }));
            return;
        }
        const updatedVmTable = vmTable.filter(vm => vm.id !== vmId);
        setVmTable(updatedVmTable);
        const updatedTableData = tableData.filter(vm => vm.id !== vmId);
        setTableData(updatedTableData);
    };
    const deleteVmFromNewTemplateTable = (vmId: string) => {
        setNewVmTable(prev => prev.filter(item => item.id !== vmId));
        setNewTableData(prev => prev.filter(item => item.id !== vmId));
        setNewVmsList(prev => prev.filter(item => item.id !== vmId));
        setNewSelectedVms(prev => {
            const updated = { ...prev };
            delete updated[vmId];
            return updated;
        });
        setGeneralDetailsFormError(prev => ({
            ...prev,
            atleastonevm: ''
        }));
    };

    const handleTemplateSelection = (templateData: any) => {
        if (templateData && templateData.id) {
            setVmFormError(prev => ({
                ...prev,
                atleastoneVm: ''
            }));
            const templatesList = templatesTableData.vAppTemplates;
            const completeTemplateData = templatesList.find(
                (template: any) => template.vmDetails.vmId === templateData.id
            );
            if (completeTemplateData) {
                setSelectedTemplateData({
                    ...completeTemplateData,
                    selectedId: templateData.id
                });
            } else {
                setSelectedTemplateData(templateData);
            }
        }
    };
    const getVmPowerStatus = (vmData: any): boolean => {
        if (!originalFormData || !originalFormData.vmDetails || !Array.isArray(originalFormData.vmDetails)) {
            return false;
        }
        const isVMExists = originalFormData.vmDetails.find((vm: any) => vm.vmID === vmData.vmID);
        return isVMExists ? isVMExists.powerOn || false : false;
    };
    const getPrimaryNicStatus = (nic: any): boolean => {
        if (!originalFormData || !originalFormData.vmDetails || !Array.isArray(originalFormData.vmDetails) || !selectedVmId) {
            return false;
        }
        const originalVM = originalFormData.vmDetails.find((vm: any) => vm.id === selectedVmId);
        if (!originalVM || !originalVM.nicConfig) {
            return false;
        }
        const originalNic = originalVM.nicConfig.find((originalNicItem: any) => originalNicItem.NICId === nic.id);
        return originalNic ? originalNic.IsPrimary || originalNic.isPrimary : false;
    };

    const handleBackLinkClick = () => {
        const pathSegment = window.location.pathname.split("/academy")[1]?.split('/')[1];
        const highlightPaths = [LIBRARY_ROUTES.CREATE_COURSE, LIBRARY_ROUTES.COPY_COURSE, LIBRARY_ROUTES.EDIT_COURSE, LIBRARY_ROUTES.START_COURSE_INSTANCE, LIBRARY_ROUTES.EDIT_COURSE_INSTANCE];
        if (highlightPaths.includes(pathSegment)) {
            setConfirmationSource('back');
            setShowCancelConfirmation(true)
        }
        else {
            navigate(CREATE_COURSE_CONSTANTS.BACK_LINK_URL);
        }
    };
    const handleCancelClick = () => {
        setConfirmationSource('cancel');
        setShowCancelConfirmation(true);
    };
    const handleCloseViewVmModal = () => {
        setShowViewVmDetailsModal(false);
        closeAndReset(true, true);
    }
    const handleGeneralDetailsFieldChange = (
        field: 'courseName' | 'description' | 'courseDuration',
        value: string
    ) => {
        handleGenDetailForm(field, value);
    };

    /**
     * ✅ Handler for general details field blur events
     */
    const handleGeneralDetailsFieldBlur = (
        field: 'courseName' | 'description' | 'courseDuration'
    ) => {
        if (field === 'courseName') {
            const courseNameError: any = validateCourseName(generalDetails.courseName);
            setGeneralDetailsFormError(prev => ({
                ...prev,
                courseName: courseNameError
            }));
        } else if (field === 'description') {
            const descriptionError = validateDescription(generalDetails.courseDescription);
            setGeneralDetailsFormError(prev => ({
                ...prev,
                description: descriptionError
            }));
        } else if (field === 'courseDuration') {
            const durationError = validateCourseDuration(
                generalDetails.courseDuration?.toString() || ''
            );
            setGeneralDetailsFormError(prev => ({
                ...prev,
                courseDuration: durationError
            }));
        }
    };
    const handleConfirmPublish = () => {
        saveAndPublishCourse('publish');
    };
    /**
     * This function returns the headers for the existing VM table. 
     * @returns An array of header objects for the existing VM table.
     */
    const getExistingVmHeaders = () => {
        return existingVmTableHeaders.map(header => {
            if (header.id === 'select') {
                return {
                    ...header,
                    content: (
                        <Checkbox
                            id="select-all-vappTemplate"
                            data-testid="select-all-vappTemplate"
                            onChange={toggleSelectALl}
                            indeterminate={isNotEmpty(selectedItemsIds) && selectedItemsIds.length !== tableData.length}
                            checked={tableData.length > 0 && selectedItemsIds.length === tableData.length}
                            disabled={!vmTable.length}
                        />
                    )
                };
            } if (header.id === 'vmPause' && isEditMode) {
                return {
                    ...header,
                    canResize: true
                };
            }
            return header;
        });
    };

    /**
     * This function formats the RAM value for display in the VM table.
     * @param ram 
     * @param ramUnit 
     * @returns 
     */

    const getRamValue = (ram: any, ramUnit: string): string => {
        if (!ram || ram === '') return '--';
        const ramStr = String(ram);
        // Check if unit is already included
        if (ramStr.includes('MB') || ramStr.includes('GB')) {
            return ramStr;
        }
        // Append unit if not present
        return `${ram} ${ramUnit}`;
    };

    /**
     * This function formats the CPU value for display in the VM table.
     * @param cpu 
     * @returns 
     */
    const getCpuValue = (cpu: any): string => {
        if (!cpu || cpu === '') return '--';
        const cpuStr = String(cpu);
        if (cpuStr.includes('Core') || cpuStr.includes('Cores')) {
            return cpuStr;
        }
        const cpuNum = parseInt(cpuStr);
        return `${cpuStr} ${cpuNum === 1 ? 'Core' : 'Cores'}`;
    };

    /**
     * This function formats the storage value for display in the VM table.
     * @param storage 
     * @returns 
     */

    const getStorageValue = (storage: any): string => {
        if (!storage || storage === '') return '--';
        const storageStr = String(storage);
        if (storageStr.includes('GB')) {
            return storageStr;
        }
        return `${storageStr} GB`;
    };
    /**
     * This functions checks if any VM in the existing VM table is in an intermediate state 
     * (e.g., being created, updated, or deleted) and returns a boolean to disable parent buttons accordingly. 
     * @returns 
     */
    const disableParentBtns = (): boolean => {
        if (vmTable.length === 0) return false;
        return vmTable.some(vm => (vm.intermediateStatus ?? "") !== "");
    }

    /**
     * This function builds a row for the existing VM table. It includes a checkbox for selection, 
     * displays VM details, and shows an edit button in edit mode. The VM name is clickable to get power status and MKS token if the VM is powered on.
     * @param data 
     * @param index 
     * @param isSelected 
     * @returns 
     */

    const buildExistingVmTableRow = (data: IVMTable, index: number, isSelected: boolean) => {
        const cells = [
            // Checkbox cell
            {
                content: !isEditMode ? (
                    <Checkbox
                        id={`vm-course-row-${index}-select`}
                        data-testid={`vm-course-row-${index}-select`}
                        checked={isSelected}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => onItemSelect(data, e.target.checked)}
                    />
                ) : null,
                className: '!w-[50px] !min-w-[50px] !max-w-[50px] text-center vpp-table-border'
            },
            // VM Name cell
            {
                content: (
                    <div onClick={() => {
                        if (getVmPowerStatus(data) && !(disableParentBtns())) { 
                            getMksToken(data); 
                        }
                    }}
                        className={`${getVmPowerStatus(data) && !(disableParentBtns()) ? "cursor-pointer" : ""} flex items-center gap-1 w-full`}
                    >
                        <TextOverflow
                            tooltipPosition="top"
                            className={`!max-w-[140px] flex-1 ${(isEditMode && getVmPowerStatus(data) && !(disableParentBtns())) ? 'cursor-pointer' : ''} ${data.isNewlyAdded ? 'text-[#808080]' : ''}`}
                        >
                            {data.vmName}
                        </TextOverflow>
                        {data.vmPause === "Yes" && (
                            <Tooltip content="Allow auto pause enabled" position="bottom">
                                <img src={autoPause} alt="auto pause icon" className="w-4 h-4 flex-shrink-0" />
                            </Tooltip>
                        )}
                    </div>
                ),
                className: `!w-[140px] !min-w-[140px] !max-w-[140px] table-body-cell ${(isEditMode && getVmPowerStatus(data) && !(disableParentBtns())) ? 'light-blue' : ''}`
            },
            // OS Type cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {data.osType !== null && data.osType !== "" ? data.osType : '--'}
                    </TextOverflow>
                ),
                className: '!w-[100px] !min-w-[100px] !max-w-[100px] table-body-cell'
            },
            // OS Version cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {data.osVersion !== null && data.osVersion !== "" ? data.osVersion : '--'}
                    </TextOverflow>
                ),
                className: '!w-[110px] !min-w-[110px] !max-w-[110px] table-body-cell'
            },
            // RAM cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {getRamValue(data.ram, data.ramUnit)}
                    </TextOverflow>
                ),
                className: '!w-[87px] !min-w-[87px] !max-w-[87px] table-body-cell'
            },
            // CPU cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {/* {data.cpu !== null && data.cpu !== "" ? `${data.cpu} ${parseInt(data.cpu) === 1 ? 'Core' : 'Cores'}` : '--'} */}
                        {getCpuValue(data.cpu)}
                    </TextOverflow>
                ),
                className: '!w-[90px] !min-w-[90px] !max-w-[90px] table-body-cell'
            },
            // IP Address cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {data.ipAddress !== null && data.ipAddress !== "" ? data.ipAddress : '--'}
                    </TextOverflow>
                ),
                className: '!w-[127px] !min-w-[127px] !max-w-[127px] table-body-cell'
            },
            // Storage cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {getStorageValue(data.storage)}
                    </TextOverflow>
                ),
                className: '!w-[90px] !min-w-[90px] !max-w-[90px] table-body-cell'
            },
            // VM Pausable cell
            {
                content: (
                    <TextOverflow lines={1} tooltipPosition="top" className={`${data.isNewlyAdded ? 'text-[#808080]' : ''}`}>
                        {data.vmPause !== null && data.vmPause !== "" ? data.vmPause : '--'}
                    </TextOverflow>
                ),
                className: '!w-[100px] !min-w-[100px] !max-w-[100px] table-body-cell'
            },
            // Actions cell
            {
                content: isEditMode ? (
                    <div className="flex space-x-2 justify-center">
                        {data.powerOn && (
                            <button
                                data-testid={`power-off-vm-${index}`}
                                onClick={() => handleVmPowerOff(true, data)}
                                disabled={generalDetails.courseStage !== 3 || (data.isNewlyAdded && !data.isFromAPI) || disableParentBtns()}
                                className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                title="Power Off VM"
                            >
                                <img
                                    src={powerOffIcon}
                                    alt="Power Off VM"
                                    className="w-4 h-4 flex-shrink-0"
                                />
                            </button>
                        )}
                        {!data.powerOn && (
                            <button
                                data-testid={`power-on-vm-${index}`}
                                onClick={() => handleVmPowerOn(data)}
                                disabled={generalDetails.courseStage !== 3 || (data.isNewlyAdded && !data.isFromAPI) || disableParentBtns()}
                                className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                title="Power On VM"
                            >
                                <img
                                    src={powerOnIcon}
                                    alt="Power On VM"
                                    className="w-4 h-4 flex-shrink-0"
                                />
                            </button>
                        )}
                        <button
                            data-testid={`mount-iso-${index}`}
                            onClick={() => handleMountIsoForVM(true, data)}
                            disabled={generalDetails.courseStage !== 3 || (data.isNewlyAdded && !data.isFromAPI) || disableParentBtns()}
                            className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                            title="Insert Media"
                        >
                            <img
                                src={mountIso}
                                alt="Insert Media"
                                className="w-4 h-4 flex-shrink-0"
                            />
                        </button>
                        <button
                            data-testid={`un-mount-iso-${index}`}
                            onClick={() => handleUnMountIsoForVM(data)}
                            disabled={generalDetails.courseStage !== 3 || (data.isNewlyAdded && !data.isFromAPI) || disableParentBtns()}
                            className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                            title="Eject Media"
                        >
                            <img
                                src={unmountIso}
                                alt="Eject Media"
                                className="w-4 h-4 flex-shrink-0"
                            />
                        </button>

                        {/* View Icon - ONLY for newly created VMs from template */}
                        {data.isNewlyAdded && !data.isFromAPI && data.isFromTemplate ? (
                            <button
                                id={`view-vm-${index}`}
                                data-testid={`view-vm-${index}`}
                                onClick={() => handleViewVM(data)}
                                disabled={generalDetails.courseStage !== 3 || disableParentBtns()}
                                className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                title="View VM"
                            >
                                <ShowIcon strokeWidth={2} className="w-4 h-4" />
                            </button>
                        ) : (
                            /* Edit Icon - For all other cases */
                            <button
                                id={`edit-vm-${index}`}
                                data-testid={`edit-vm-${index}`}
                                onClick={() => handleEditVM(data)}
                                disabled={generalDetails.courseStage !== 3 || disableParentBtns()}
                                className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                                title="Edit VM"
                            >
                                <EditIcon strokeWidth={2} className="w-4 h-4" />
                            </button>
                        )}
                        {/* Disable the actions button if course stage is not 3 - If it is not Draft State*/}
                        <button
                            data-testid={`replace-vm-${index}`}
                            onClick={() => deleteVmFromExitingTemplateTable(data.id)}
                            disabled={generalDetails.courseStage !== 3 || disableParentBtns()}
                            className="p-1 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed inline-flex items-center justify-center"
                            title="Delete VM"
                        >
                            <TrashIcon strokeWidth={2} className="w-4 h-4" />
                        </button>
                    </div>
                ) : null,
                className: '!w-[90px] !min-w-[90px] !max-w-[90px] table-body-cell'
            }
        ];

        // Filter out checkbox in edit mode, filter out actions in create mode
        return {
            id: `table-${index}`,
            cell: isEditMode
                ? cells.filter((_, idx) => idx !== 0) // Remove checkbox in edit mode
                : cells.filter((_, idx) => idx !== cells.length - 1) // Remove actions in create mode
        };
    };
    /**
     * This function handles the sorting of the existing VM table when a column header is clicked. 
     * It sorts the table data based on the selected column and direction, and updates the sort indicators in the headers.
     * @param direction 
     * @param id 
     * @returns 
     */
    const handleExistingVmTableSort = (direction: 'asc' | 'desc' | undefined, id: string) => {
        if (!direction) {
            // Reset to original order
            setVmTable(tableData);
            const updatedHeaders = existingVmTableHeaders.map(header => ({
                ...header,
                sort: undefined
            }));
            setExistingVmTableHeaders(updatedHeaders);
            return;
        }
        // Column mapping
        const columnMap: Record<string, keyof IVMTable> = {
            'vmName': 'vmName',
            'osType': 'osType',
            'osVersion': 'osVersion',
        };

        const sortKey = columnMap[id];
        // Sort the data
        const sortedData = [...vmTable].sort((a: any, b: any) => {
            let valueA = a[sortKey];
            let valueB = b[sortKey];
            valueA = String(valueA || '').toLowerCase();
            valueB = String(valueB || '').toLowerCase();
            return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });

        // Update header sort indicators
        const updatedHeaders = existingVmTableHeaders.map(header => ({
            ...header,
            sort: header.id === id ? direction : undefined
        }));

        setExistingVmTableHeaders(updatedHeaders);
        setVmTable(sortedData);
    };

    /**
     * This function returns the headers for the new VM table. It adds a checkbox to the header for selecting all VMs.
     * @returns 
     */
    const getNewVmHeaders = () => {
        return newVmTableHeaders.map(header => {
            if (header.id === 'select') {
                return {
                    ...header,
                    content: (
                        <Checkbox
                            id="new-vm-table-select-all-vappTemplate"
                            data-testid="new-vm-table-select-all-vappTemplate"
                            onChange={toggleSelectAllNewVmTable}
                            indeterminate={isNotEmpty(newSelectedItemsIds) && newSelectedItemsIds.length !== newTableData.length}
                            checked={newTableData.length > 0 && newSelectedItemsIds.length === newTableData.length}
                            disabled={!newVmTable.length}
                        />
                    )
                };
            }
            return header;
        });
    };

    /**
     * This function builds a row for the new VM table. It includes a checkbox for selection, displays VM details
     * @param data 
     * @param index 
     * @param isSelected 
     * @returns 
     */
    const buildNewVmTableRow = (data: IVMTable, index: number, isSelected: boolean) => {
        const cells = [
            // Checkbox cell
            {
                content: !isEditMode ? (
                    <Checkbox
                        id={`new-vm-course-row-${index}-select`}
                        data-testid={`new-vm-course-row-${index}-select`}
                        checked={isSelected}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => onItemSelectNewVmTable(data, e.target.checked)}
                    />
                ) : null,
                className: 'check-box-cell'
            },
            // VM Name cell
            {
                content: (
                    <div className="flex items-center gap-3 w-full">
                        <TextOverflow tooltipPosition="top" className="flex-1">
                            {data.vmName}
                        </TextOverflow>
                        {data.vmPause === "Yes" && (
                            <Tooltip content="Allow auto pause enabled" position="bottom">
                                <img src={autoPause} alt="auto pause icon" className="w-4 h-4 flex-shrink-0" />
                            </Tooltip>
                        )}
                    </div>
                ),
                className: '!w-[99px] !min-w-[90px] !max-w-[99px] table-body-cell'
            },
            // OS Type cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{data.osType}</TextOverflow>,
                className: '!w-[99px] !min-w-[90px] !max-w-[99px] table-body-cell'
            },
            // OS Version cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{data.osVersion}</TextOverflow>,
                className: '!w-[105px] !min-w-[105px] !max-w-[105px] table-body-cell'
            },
            // RAM cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{getRamValue(data.ram, data.ramUnit)}</TextOverflow>,
                className: '!w-[83px] !min-w-[83px] !max-w-[83px] table-body-cell'
            },
            // CPU cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{getCpuValue(data.cpu)}</TextOverflow>,
                className: '!w-[90px] !min-w-[90px] !max-w-[90px] table-body-cell'
            },
            // IP Address cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{data.ipAddress}</TextOverflow>,
                className: '!w-[100px] !min-w-[100px] !max-w-[100px] table-body-cell'
            },
            // Storage cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{getStorageValue(data.storage)}</TextOverflow>,
                className: '!w-[90px] !min-w-[90px] !max-w-[90px] table-body-cell'
            },
            // VM Pause cell
            {
                content: <TextOverflow lines={1} tooltipPosition="top">{data.vmPause}</TextOverflow>,
                className: '!w-[75px] !min-w-[75px] !max-w-[75px] table-body-cell'
            },
            // Actions cell
            {
                content: (
                    <div className="flex space-x-2">
                        <button
                            id={`new-vm-table-delete-vm-${index}`}
                            data-testid={`new-vm-table-delete-vm-${index}`}
                            onClick={() => deleteVmFromNewTemplateTable(data.id)}
                        >
                            <TrashIcon strokeWidth={2} />
                        </button>
                    </div>
                ),
                className: 'table-body-cell'
            }
        ];

        return {
            id: `new-vm-table-${index}`,
            cell: isEditMode ? cells.filter((_, idx) => idx !== 0) : cells // Remove checkbox in edit mode
        };
    };
    /**
     * This function handles the sorting of the new VM table when a column header is clicked.
     * @param direction The direction of the sort ('asc' for ascending, 'desc' for descending, undefined for no sort)
     */
    const handleNewVmTableSort = (direction: 'asc' | 'desc' | undefined, id: string) => {
        if (!direction) {
            // Reset to original order
            setNewVmTable(newTableData);
            const updatedHeaders = newVmTableHeaders.map(header => ({
                ...header,
                sort: undefined
            }));
            setNewVmTableHeaders(updatedHeaders);
            return;
        }
        // Column mapping
        const columnMap: Record<string, keyof IVMTable> = {
            'vmName': 'vmName',
            'osType': 'osType',
            'osVersion': 'osVersion'
        };
        const sortKey = columnMap[id];
        // Sort the data
        const sortedData = [...newVmTable].sort((a: any, b: any) => {
            let valueA = a[sortKey];
            let valueB = b[sortKey];
            valueA = String(valueA || '').toLowerCase();
            valueB = String(valueB || '').toLowerCase();
            return direction === 'asc' ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
        });

        // Update header sort indicators
        const updatedHeaders = newVmTableHeaders.map(header => ({
            ...header,
            sort: header.id === id ? direction : undefined
        }));

        setNewVmTableHeaders(updatedHeaders);
        setNewVmTable(sortedData);
    };
    return (
        <>
            <div className="h-full flex">
                <div className="h-full">
                    <LeftPanel showLeftPanel={showLeftPanel} />
                </div>
                <div className="w-full text-white p-4">
                    <div className="mt-3">
                        <Header handleClickHam={handleClickHam} />
                    </div>
                    <div className="body-container">
                        <CreateCourseHeader
                            isEditMode={isEditMode}
                            courseName={generalDetails.courseName}
                            onBackLinkClick={handleBackLinkClick}
                        />
                        <div className="px-5">
                            <Accordion className="mx-auto w-[70vw] min-w-full max-w-4xl dark:bg-container-dark xl-low:!pb-[50px] xl-mid:!pb-[50px] xl-high:!pb-0  rounded-lg" id="accordion" multi={true} data-testid="accordion" defaultOpenIndex={[0, 1]}>
                                <AccordionItem
                                    id="generalDetails"
                                    data-testid="generalDetails"
                                    title={
                                        <div className="flex items-center">
                                            <span className="generatl-details-accordion">
                                                {CREATE_COURSE_CONSTANTS.GENERAL_DETAILS.TITLE}
                                            </span>
                                        </div>
                                    }
                                >
                                    <GeneralDetailsSection
                                        generalDetails={generalDetails}
                                        generalDetailsFormError={generalDetailsFormError}
                                        isEditMode={isEditMode}
                                        onFieldChange={handleGeneralDetailsFieldChange}
                                        onFieldBlur={handleGeneralDetailsFieldBlur}
                                    />

                                </AccordionItem>
                                <AccordionItem id="vpp-template-details" data-testid="vpp-template-details"
                                    title={
                                        <div className="flex items-center">
                                            <span className="generatl-details-accordion">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TITLE}</span>
                                        </div>
                                    }>
                                    <div className="w-full max-w-2xl">
                                        {!isCopyMode && !isEditMode && (
                                            <div>
                                                <div className="mb-4">
                                                    <Label required className="vapp-template-details">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_ASSOCIATION.LABEL}</Label>
                                                    <RadioButtonGroup
                                                        id="existingTemplate"
                                                        data-testid="existingTemplate"
                                                        className="text-base mt-4"
                                                        orientation="horizontal"
                                                        name="templateAssociation"
                                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleGenDetailForm('templateAssociate', e.target.value)}
                                                    >
                                                        <RadioButton
                                                            id="existingTemplateRadio"
                                                            data-testid="existingTemplateRadio"
                                                            value="existing"
                                                            disabled={isEditMode}
                                                            defaultChecked={templateAssociation === 'existing'}>
                                                            <label className="existing-vapp mr-12">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_ASSOCIATION.OPTIONS.EXISTING}</label>
                                                        </RadioButton>
                                                        <RadioButton
                                                            id="newTemplateRadio"
                                                            data-testid="newTemplateRadio"
                                                            value="new"
                                                            disabled={isEditMode}
                                                            defaultChecked={templateAssociation === 'new'}>
                                                            <label className="existing-vapp">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_ASSOCIATION.OPTIONS.NEW}</label>
                                                        </RadioButton>
                                                    </RadioButtonGroup>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <div className="grid grid-cols-3">
                                        {templateAssociation !== 'new' && !isCopyMode && !isEditMode ? (
                                            <div>
                                                <div className="mt-4">
                                                    <Label required className="createCourse-label mb-2">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.EXISTING_TEMPLATE.LABEL}</Label>
                                                    <div className="filterBy">
                                                        {!isEditMode && (
                                                            <Select
                                                                className={`createCourse-vpp-template !outline-none ${!generalDetailsFormError.vAppTemplate ? '!border-none' : ''}`}
                                                                id="select-existing-vApp"
                                                                data-testid="select-existing-vApp"
                                                                height={4}
                                                                value={generalDetails.vAppTemplate || ''}
                                                                onChange={(e) => handleGenDetailForm('vAppTemplate', e.target.value)}
                                                                placeholder={CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.EXISTING_TEMPLATE.PLACEHOLDER}
                                                                search={
                                                                    <SelectOptionSearch
                                                                        className="text-base"
                                                                        label="Search"
                                                                        onChange={(e) => setTemplateSearchQuery(e.target.value)}
                                                                        placeholder="Search"
                                                                        value={templateSearchQuery}
                                                                    />}
                                                                size="regular"
                                                                error={generalDetailsFormError.vAppTemplate !== ''}
                                                            >
                                                                {
                                                                    getFilteredTemplates().map((template: any, index: any) => (
                                                                        <SelectOption
                                                                            className="text-sm font-normal"
                                                                            id={`template-option-${index}`}
                                                                            data-testid={`template-option-${index}`}
                                                                            key={index}
                                                                            label={template.name}
                                                                            value={template.id}
                                                                        />
                                                                    ))
                                                                }
                                                            </Select>
                                                        )}
                                                    </div>
                                                    {generalDetailsFormError.vAppTemplate === '' && (
                                                        <div className="text-sm text-gray-400 mt-1 text-xs">
                                                            Only 1 template can be associated
                                                        </div>
                                                    )}
                                                    {generalDetailsFormError.vAppTemplate && (
                                                        <ControlError className="text-xs" showIcon={false}>{generalDetailsFormError.vAppTemplate}</ControlError>
                                                    )}
                                                </div>
                                                {generalDetails.vAppTemplate && (
                                                    <div className="mt-4">
                                                        <Label required className="createCourse-label mb-2">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_NAME.LABEL}</Label>
                                                        <Input
                                                            id="vApp-template-name"
                                                            className={`createCourse-newTemplate-input-field ${!generalDetailsFormError.vAppTemplateName ? '!border-none' : ''}`}
                                                            data-testid="vApp-template-name"
                                                            disabled={isEditMode}
                                                            size="regular"
                                                            onChange={(e) => handleGenDetailForm('vAppTemplateName', e.target.value)}
                                                            onBlur={() => {
                                                                const templateNameError = validateTemplateName(generalDetails.vAppTemplateName);
                                                                setGeneralDetailsFormError(prev => ({
                                                                    ...prev,
                                                                    vAppTemplateName: templateNameError
                                                                }));
                                                            }}
                                                            error={generalDetailsFormError.vAppTemplateName !== ''}
                                                            placeholder={CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_NAME.PLACEHOLDER}
                                                            value={generalDetails.vAppTemplateName}
                                                            autoComplete="off"
                                                        />
                                                        {generalDetailsFormError.vAppTemplateName === '' && (
                                                            <div className="text-sm text-gray-400 mt-1 text-xs">
                                                                Max 50 characters
                                                            </div>
                                                        )}
                                                        {generalDetailsFormError.vAppTemplateName && (
                                                            <ControlError className="text-xs" showIcon={false}>{generalDetailsFormError.vAppTemplateName}</ControlError>
                                                        )}
                                                    </div>
                                                )}
                                            </div>
                                        ) : (
                                            <div className="w-screen min-w-48 max-w-96">
                                                <Label required className="createCourse-label mb-2">{CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_NAME.LABEL}</Label>
                                                <Input
                                                    id="vApp-template-name"
                                                    className={`createCourse-newTemplate-input-field ${!generalDetailsFormError.vAppTemplateName ? '!border-none' : ''}`}
                                                    data-testid="vApp-template-name"
                                                    size="regular"
                                                    // disabled={isEditMode}
                                                    onChange={(e) => handleGenDetailForm('vAppTemplateName', e.target.value)}
                                                    onBlur={() => {
                                                        const templateNameError = validateTemplateName(generalDetails.vAppTemplateName);
                                                        setGeneralDetailsFormError(prev => ({
                                                            ...prev,
                                                            vAppTemplateName: templateNameError
                                                        }));
                                                    }}
                                                    error={generalDetailsFormError.vAppTemplateName !== ''}
                                                    placeholder={CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.TEMPLATE_NAME.PLACEHOLDER}
                                                    value={generalDetails.vAppTemplateName}
                                                    autoComplete="off"
                                                />
                                                {generalDetailsFormError.vAppTemplateName === '' && (
                                                    <div className="text-sm text-gray-400 mt-1 text-xs">
                                                        Max 50 characters
                                                    </div>
                                                )}
                                                {generalDetailsFormError.vAppTemplateName && (
                                                    <ControlError className="text-xs" showIcon={false}>{generalDetailsFormError.vAppTemplateName}</ControlError>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                    {/* EXISTING TEMPLATE */}
                                    {templateAssociation === 'existing' && (generalDetails.vAppTemplate || isEditMode) && (
                                        <div>
                                            <Card className="border-unset mt-4">
                                                <CardHeader>
                                                    <div className="grid grid-cols-4 gap-4 items-center w-full">
                                                        <div className="col-span-1 !p-0">
                                                            <Input
                                                                id="search-input-vAppName"
                                                                data-testid="search-input-vAppName"
                                                                className="search-template-input-field w-[370px]"
                                                                placeholder={`Search by ${filterType === 'Name' ? 'Name' : 'OS Type'}`}
                                                                onChange={(e) => handleSearchChange(e)}
                                                                prefix={<SearchIcon strokeWidth={2} />}
                                                                size="regular"
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                        <div className="col-span-1 filterBy !p-0">
                                                            <Select
                                                                key={`filter-select-${filterType}`}
                                                                height={1}
                                                                className="text-sm font-normal font-w-400 !border-none !outline-none filter-by-vapp w-[370px]"
                                                                id="filter-tempName"
                                                                data-testid="filter-tempName"
                                                                onChange={(e) => handleFilterTypeChange(e)}
                                                                placeholder={filterType === 'Name' ? 'Name' : 'OS Type'}
                                                                defaultValue={filterType}
                                                                size="regular"
                                                            >
                                                                <SelectOption
                                                                    label={CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.FILTER.OPTIONS.TEMPLATE_NAME}
                                                                    value={'Name'}
                                                                    className="text-sm font-normal"
                                                                />
                                                                <SelectOption
                                                                    label={CREATE_COURSE_CONSTANTS.VAPP_TEMPLATE_DETAILS.FILTER.OPTIONS.OS_TYPE}
                                                                    value={'OS Type'}
                                                                    className="text-sm font-normal"
                                                                />
                                                            </Select>
                                                        </div>
                                                        <div className="col-span-2 text-sm text-end !p-0">
                                                            <span>
                                                                {paginationInfo.total > 0
                                                                    ? `${paginationInfo.start}-${paginationInfo.end} of ${paginationInfo.total}`
                                                                    : 'No results'
                                                                }
                                                            </span>
                                                            {(filterType && searchQuery.trim()) && (
                                                                <>
                                                                    <span className="mr-2 ml-2">|</span>
                                                                    <span className="filter-applied">
                                                                        {'Filter applied by ' + (filterType === 'Name' ? 'Name' : 'OS Type')}
                                                                    </span>
                                                                </>
                                                            )}
                                                            {(!filterType || !searchQuery.trim()) && (
                                                                <>
                                                                    <span className="mr-2 ml-2">|</span>
                                                                    <span className="filter-applied">
                                                                        {'Filter applied by ' + (filterType === 'Name' ? 'Name' : 'OS Type')}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </CardHeader>
                                                <CardContent x="none" y="none" className="overflow-y-auto xl-low:!vm-table-height-small xl-mid:!vm-table-height-medium xl-high:!vm-table-height-large">
                                                    {/* EXISTING TEMPLATE */}
                                                    <Table onCard>
                                                        <TableHeader
                                                            data={isEditMode
                                                                ? getExistingVmHeaders().filter(h => h.id !== 'select')
                                                                : getExistingVmHeaders().filter(h => h.id !== 'actions')
                                                            }
                                                            variant="default"
                                                            onSort={handleExistingVmTableSort}
                                                        />

                                                        {isVmTableLoading ? (
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell colSpan={isEditMode ? 10 : 9} className="text-center">
                                                                        <div className="xl-low:my-20 xl-mid:my-32 xl-high:my-68">
                                                                            <ContentLoader className="mt-8">Loading</ContentLoader>
                                                                        </div>
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        ) : vmTable.length > 0 ? (
                                                            <TableContent
                                                                data={vmTable.map((data, i) => {
                                                                    const _isSelected = selectedItemsIds.includes(data.id);
                                                                    return buildExistingVmTableRow(data, i, _isSelected);
                                                                })}
                                                                variant="compact"
                                                            />
                                                        ) : (
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell
                                                                        colSpan={isEditMode ? 10 : 9}
                                                                        className="text-center text-sm font-bold vpp-table-border"
                                                                    >
                                                                        No data found
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        )}
                                                    </Table>
                                                </CardContent>
                                            </Card>
                                            <Button
                                                className="text-base font-w-500 mt-4"
                                                id="create-new-vm"
                                                data-testid="create-new-vm"
                                                icon={<PlusIcon strokeWidth={2} />}
                                                disabled={disableParentBtns()}
                                                onClick={createNewVm}
                                                size="regular"
                                                variant="primary"
                                                iconPosition="right"
                                            >
                                                {CREATE_COURSE_CONSTANTS.BUTTONS.ADD_VM}
                                            </Button>
                                        </div>
                                    )}
                                    {/* NEW TEMPLATE */}
                                    {templateAssociation === 'new' && (
                                        <div>
                                            <Card className="border-unset mt-4">
                                                <CardContent x="none" y="none" className="overflow-y-auto xl-low:!vm-table-height-small xl-mid:!vm-table-height-medium xl-high:!vm-table-height-large">
                                                    <Table onCard>
                                                        <TableHeader
                                                            data={isEditMode
                                                                ? getNewVmHeaders().filter(h => h.id !== 'select')
                                                                : getNewVmHeaders()
                                                            }
                                                            variant="default"
                                                            onSort={handleNewVmTableSort}
                                                        />
                                                        {newVmTable.length > 0 ? (
                                                            <TableContent
                                                                data={newVmTable.map((data, i) => {
                                                                    const _isSelected = newSelectedItemsIds.includes(data.id);
                                                                    return buildNewVmTableRow(data, i, _isSelected);
                                                                })}
                                                            />
                                                        ) : (
                                                            <TableBody>
                                                                <TableRow>
                                                                    <TableCell
                                                                        colSpan={isEditMode ? 9 : 10}
                                                                        className="text-center text-sm font-bold vpp-table-border"
                                                                    >
                                                                        No data found
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableBody>
                                                        )}
                                                    </Table>
                                                </CardContent>
                                            </Card>
                                            <Button
                                                className="text-base font-w-500 mt-4"
                                                id="create-new-vm"
                                                data-testid="create-new-vm"
                                                disabled={disableParentBtns()}
                                                icon={<PlusIcon strokeWidth={2} />}
                                                onClick={createNewVm}
                                                size="regular"
                                                variant="primary"
                                                iconPosition="right"
                                            >
                                                {CREATE_COURSE_CONSTANTS.BUTTONS.ADD_VM}
                                            </Button>
                                        </div>
                                    )}
                                </AccordionItem>
                            </Accordion>
                            {/* Enable the buttons only for course stage 3 - Only for Draft state */}
                            {(!isEditMode || (isEditMode && generalDetails.courseStage === 3)) && (
                                <div className="display flex justify-end mt-4">
                                    <Button
                                        className="text-base font-w-700 mr-4"
                                        id="cancel-create-course"
                                        data-testid="cancel-create-course"
                                        disabled={disableParentBtns()}
                                        onClick={handleCancelClick}
                                        size="regular"
                                        variant="secondary"
                                        iconPosition="right"
                                    >
                                        {CREATE_COURSE_CONSTANTS.BUTTONS.CANCEL}
                                    </Button>
                                    <Button
                                        className="text-base font-w-700 mr-4"
                                        id="save-course-defintion"
                                        data-testid="save-course-defintion"
                                        onClick={() => saveAndPublishCourse('draft')}
                                        disabled={disableParentBtns()}
                                        size="regular"
                                        variant={isEditMode ? 'secondary' : 'primary'}
                                        iconPosition="right"
                                    >
                                        {isEditMode ? CREATE_COURSE_CONSTANTS.BUTTONS.UPDATE_BTN : isCopyMode ? CREATE_COURSE_CONSTANTS.BUTTONS.COPY_BTN : CREATE_COURSE_CONSTANTS.BUTTONS.SAVE_BTN}
                                    </Button>
                                    {isEditMode && (
                                        <Button
                                            className="text-base font-w-700 mr-4"
                                            id="publish-course-defintion"
                                            data-testid="publish-course-defintion"
                                            disabled={disableParentBtns()}
                                            onClick={() => handlePublishClick()}
                                            size="regular"
                                            variant='primary'
                                            iconPosition="right"
                                        >
                                            {CREATE_COURSE_CONSTANTS.BUTTONS.PUBLISH}
                                        </Button>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div >
            {createorEditVm && (
                <Modal
                    className="modal-wh"
                    fullContent={true}
                    backdrop={true}
                    data-testid="confirmation-modal"
                    onBackdropClick={() => { }}
                    onModalClose={setCreateorEditVm.bind(null, false)}
                >
                    <div className="modal-header">
                        <div className="modal-header-left">
                            {selectedVmId === null ? <Label className="modal-title">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.CREATE_TITLE}</Label> :
                                <Label className="modal-title">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.UPDATE_TITLE} - {vmFormData.vmName} </Label>
                            }
                        </div>
                        <div className="modal-header-right flex items-center gap-4">
                            {showPowerOn && (
                                <div className="flex items-center gap-2">
                                    <Label className="powerOn-label m-0">
                                        {vmFormData.powerOn
                                            ? CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.POWER_ON
                                            : CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.POWER_OFF
                                        }
                                    </Label>
                                    <Toggle
                                        id="powerStatus"
                                        data-testid="powerStatus"
                                        checked={vmFormData.powerOn}
                                        tabIndex={-1}
                                        onChange={(e) => handleVMFormChange('powerOn', e.target.checked)}
                                    />
                                </div>
                            )}
                            <Button
                                className="text-xs close-icon"
                                id="close-vm-creation-modal"
                                data-testid="close-vm-creation-modal"
                                icon={<CloseIcon strokeWidth={2} />}
                                onClick={() => closeAndReset(true, true)}
                                size="regular"
                                variant="quiet-primary"
                                aria-label="Close"
                                iconPosition="right"
                            />
                        </div>
                    </div>
                    <div className="modal-body">
                        {/* ✅ Show creation type section for: new VMs OR newly created VMs in edit mode */}
                        {(selectedVmId === null) && (
                            <>
                                <Label className="vm-creation-label">
                                    {CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.CREATION_TYPE.LABEL}
                                </Label>
                                <div className="grid grid-cols-2 mt-4">
                                    <RadioButtonGroup
                                        id="virtualMachineType"
                                        data-testid="virtualMachineType"
                                        className="text-sm"
                                        orientation="horizontal"
                                        name="vmCreationType"
                                        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleVMFormChange('creationType', e.target.value)}
                                    >
                                        <RadioButton
                                            id="newVm"
                                            data-testid="newVm"
                                            className="mr-8"
                                            value="fromVm"
                                            defaultChecked={vmFormData.creationType === 'fromVm'}
                                        >
                                            <label className="new-vm-label">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.CREATION_TYPE.OPTIONS.NEW_VM}</label>
                                        </RadioButton>
                                        <RadioButton
                                            id="from-template"
                                            data-testid="from-template"
                                            value="fromTemplate"
                                            defaultChecked={vmFormData.creationType === 'fromTemplate'}
                                        >
                                            <label className="new-vm-label">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.CREATION_TYPE.OPTIONS.FROM_TEMPLATE}</label>
                                        </RadioButton>
                                    </RadioButtonGroup>
                                </div>
                            </>
                        )}
                        {vmAssociation === 'fromVm' ? (
                            <NewVirtualMachine
                                powerOnStatus={vmPowerOnStatus}
                                vmFormData={vmFormData}
                                vmFormError={vmFormError}
                                handleVMFormChange={handleVMFormChange}
                                cpuOptions={cpuOptions}
                                availableOsVersions={availableOsVersions}
                                isEditMode={isEditMode}
                            />
                        ) : (
                            <NewVMFromExistingTemplate
                                vmFormData={vmFormData}
                                vmFormError={vmFormError}
                                handleVMFormChange={handleVMFormChange}
                                onTemplateSelect={handleTemplateSelection}
                            />
                        )
                        }
                    </div>
                    {vmAssociation === 'fromVm' && (
                        <>
                            <div className="modal-body" >
                                <div>
                                    <Label className="nic-config-title ml-2 mb-2">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.NIC_CONFIG.TABLE_TITLE}</Label>
                                    <Card className="border-unset">
                                        <CardContent x="none" y="none" className="overflow-y-auto nic-table-height">
                                            <Table>
                                                <TableHeader data={initialNicTableHeader} variant="default" canResize />
                                                {nicTableData.length > 0 ? (
                                                    <TableContent data={nicTableData} variant="compact" />
                                                ) : (
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell colSpan={initialNicTableHeader.length} className="text-center py-8 vpp-table-border">
                                                                <p className="text-sm text-gray-500">{CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.NIC_CONFIG.NOT_FOUND}</p>
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                )}
                                            </Table>
                                        </CardContent>
                                    </Card>
                                    <Button
                                        className="text-sm mt-4 mb-4 ml-4"
                                        id="add-nic"
                                        data-testid="add-nic"
                                        icon={<PlusIcon strokeWidth={2} />}
                                        onClick={handleAddNicClick}
                                        size="regular"
                                        variant="primary"
                                        iconPosition="right"
                                        disabled={originalNicData.length >= 4 || showNicForm || vmPowerOnStatus}
                                    >
                                        {CREATE_COURSE_CONSTANTS.CREATE_VM_MODAL.NIC_CONFIG.ADD_BUTTON}
                                    </Button>
                                </div>
                            </div>
                            {/* NIC Form STARTS */}
                            {showNicForm && (
                                <div className="modal-body">
                                    <NicConfiguration
                                        vmFormData={vmFormData}
                                        nicFormData={nicFormData}
                                        nicError={nicError}
                                        isEditMode={vmFormData.vmId !== ""}
                                        handleNicFormChange={handleNicFormChange}
                                        handleAddNicToTable={handleAddNicToTable}
                                        handleCancelNicToTable={handleCancelNicToTable}
                                        validateIpAddress={validateIpAddress}
                                    />
                                </div>
                            )}
                            {/* NIC Form ENDS */}
                        </>
                    )
                    }
                    {/* <div className="mt-4 p-4 bg-gray-800 rounded-md">
                        <Label className="text-base mb-2">VM Form Data (Debug):</Label>
                        <pre className="text-xs overflow-auto text-gray-300 max-h-[200px]">
                            {JSON.stringify(vmFormData, null, 2)}
                        </pre>
                    </div> */}
                    <div className="display flex justify-end mt-4 mr-4">
                        <Button
                            className="text-base mr-4"
                            id="cancel-nic"
                            data-testid="cancel-nic"
                            onClick={() => closeAndReset(true, true)}
                            size="regular"
                            variant="secondary"
                            iconPosition="right"
                        >
                            {CREATE_COURSE_CONSTANTS.BUTTONS.CANCEL}
                        </Button>
                        <Button
                            className="text-base mr-4"
                            id="save-vm"
                            data-testid="save-vm"
                            onClick={handleSaveVM}
                            disabled={isvAppVmTableLoading || showNicForm}
                            size="regular"
                            variant="primary"
                            iconPosition="right"
                        >
                            {CREATE_COURSE_CONSTANTS.BUTTONS.SAVE}
                        </Button>
                    </div>
                </Modal>
            )}
            {
                showViewVmDetailsModal && (
                    <ViewVMExistingTemplate
                        isOpen={showViewVmDetailsModal}
                        viewVmObj={viewVmDetailsData}
                        onClose={handleCloseViewVmModal}
                    />
                )
            }
            <CancelConfirmationModal
                isOpen={showCancelConfirmation}
                isEditMode={isEditMode}
                onClose={() => setShowCancelConfirmation(false)}
                onConfirm={handleContinueWithoutSaving}
            />
            <PublishWarningModal
                isOpen={showPublishWarning}
                onClose={() => setShowPublishWarning(false)}
                onPublish={handleConfirmPublish}
            />
            <PowerOffConfirmationModal
                isOpen={powerOffConfirmation}
                vmName={selectedVmNameForPowerOff}
                onClose={() => {
                    setPowerOffConfirmation(false);
                    setSelectedVmNameForPowerOff('');
                    setSelectedVmForPowerOff(null);
                }}
                onConfirm={handleConfirmPowerOff}
            />
            {showMountISOComponent &&
                (<Modal
                    className="isoMount-modal-wh"
                    fullContent={true}
                    backdrop={true}
                    data-testid="mount-iso-modal"
                    onBackdropClick={() => { }}
                    onModalClose={setShowMountISOComponent.bind(null, false)}
                >
                    <div className="modal-header">
                        <div className="modal-header-left">
                            <Label className="modal-title">{CREATE_COURSE_CONSTANTS.MOUNT_ISO_TITLE}</Label>
                        </div>
                        <div className="modal-header-right flex items-center gap-4">
                            <Button
                                className="text-xs close-icon"
                                id="close-mount-iso-modal"
                                data-testid="close-mount-iso-modal"
                                icon={<CloseIcon strokeWidth={2} />}
                                onClick={() => handleMountIsoForVM(false, {})}
                                size="regular"
                                variant="quiet-primary"
                                aria-label="Close"
                                iconPosition="right"
                            />
                        </div>
                    </div>
                    <div className="isoMount-modal-body">
                        <MountISOComponent
                            isoTableData={isoTableData}
                            selectedVmForInsertEject={selectedVmForPowerOff}
                            courseOrgId={generalDetails.courseOrgId}
                            courseSiteId={generalDetails.siteId}
                            handleMountISOChange={handleMountIsoForVM}
                        />
                    </div>
                </Modal>
                )
            }
            <UnMountISOConfirmationModal
                isOpen={showUnMountISOConfirmation}
                onClose={() => setShowUnMountISOConfirmation(false)}
                unMountConfirm={handleConfirmUnMountISO}
            />
        </>
    );
};

export default CreateCourse;
